// Generated by nuxt-prepare
export const header_it = {
  "subnav": [
    {
      "etichetta": "Visita",
      "link": [
        {
          "etichetta": "Cosa fare e vedere"
        },
        {
          "etichetta": "Eventi"
        },
        {
          "etichetta": "Territorio"
        },
        {
          "etichetta": "Dove dormire"
        },
        {
          "etichetta": "Dove mangiare"
        },
        {
          "etichetta": "Pianifica la tua visita"
        }
      ]
    },
    {
      "etichetta": "Convention Bureau",
      "link": [
        {
          "etichetta": "Perchè Torino"
        },
        {
          "etichetta": "Chi siamo"
        },
        {
          "etichetta": "I nostri partner"
        },
        {
          "etichetta": "Organizza il tuo evento"
        },
        {
          "etichetta": "News"
        },
        {
          "etichetta": "Contatti"
        },
        {
          "etichetta": "Congressi e Fiere"
        }
      ]
    },
    {
      "etichetta": "Travel Trade",
      "link": [
        {
          "etichetta": "Ispirazioni"
        },
        {
          "etichetta": "Noi per Te"
        },
        {
          "etichetta": "Organizza"
        },
        {
          "etichetta": "Trasporti"
        },
        {
          "etichetta": "Diventa Partner"
        },
        {
          "etichetta": "Newsletter"
        },
        {
          "etichetta": "Contatti"
        }
      ]
    },
    {
      "etichetta": "Scuole",
      "link": [
        {
          "etichetta": "Cosa fare"
        },
        {
          "etichetta": "Proposte turistiche"
        },
        {
          "etichetta": "Come muoversi"
        },
        {
          "etichetta": "Dove dormire"
        },
        {
          "etichetta": "Dove mangiare"
        },
        {
          "etichetta": "Download"
        },
        {
          "etichetta": "Contattaci"
        }
      ]
    },
    {
      "etichetta": "Press&Media",
      "link": [
        {
          "etichetta": "Comunicati stampa"
        },
        {
          "etichetta": "Press kit"
        },
        {
          "etichetta": "Rassegna stampa"
        },
        {
          "etichetta": "Media"
        }
      ]
    },
    {
      "etichetta": "Partner + Sponsorship",
      "link": [
        {
          "etichetta": "Soci"
        },
        {
          "etichetta": "Sponsor"
        },
        {
          "etichetta": "Operatori incoming"
        },
        {
          "etichetta": "Operatori congressuali"
        },
        {
          "etichetta": "Albo fornitori"
        }
      ]
    }
  ]
}
export type HeaderIt = typeof header_it
export const header_en = {
  "subnav": [
    {
      "etichetta": "Visit",
      "link": [
        {
          "etichetta": "To do and to see"
        },
        {
          "etichetta": "Events"
        },
        {
          "etichetta": "Territory"
        },
        {
          "etichetta": "Accommodation"
        },
        {
          "etichetta": "Where to eat"
        },
        {
          "etichetta": "Plan your trip"
        }
      ]
    },
    {
      "etichetta": "Convention Bureau",
      "link": [
        {
          "etichetta": "Why Torino"
        },
        {
          "etichetta": "Who we are"
        },
        {
          "etichetta": "Our partner"
        },
        {
          "etichetta": "Organise your event"
        },
        {
          "etichetta": "News"
        },
        {
          "etichetta": "Contact our team"
        },
        {
          "etichetta": "Congresses and Exhibitions"
        }
      ]
    },
    {
      "etichetta": "Travel Trade",
      "link": [
        {
          "etichetta": "Inspirations"
        },
        {
          "etichetta": "Here for you"
        },
        {
          "etichetta": "Organize"
        },
        {
          "etichetta": "Transport"
        },
        {
          "etichetta": "Our Partner"
        },
        {
          "etichetta": "Newsletter"
        },
        {
          "etichetta": "Contact our team"
        }
      ]
    },
    {
      "etichetta": "Schools",
      "link": [
        {
          "etichetta": "Plan your visit"
        },
        {
          "etichetta": "tourist proposal"
        },
        {
          "etichetta": "Getting Around"
        },
        {
          "etichetta": "Accommodation"
        },
        {
          "etichetta": "Where to eat"
        },
        {
          "etichetta": "Download"
        },
        {
          "etichetta": "Contact us"
        }
      ]
    },
    {
      "etichetta": "Media",
      "link": [
        {
          "etichetta": null
        },
        {
          "etichetta": "Press kit"
        },
        {
          "etichetta": "Press review"
        },
        {
          "etichetta": "Media"
        }
      ]
    },
    {
      "etichetta": "Partner + Sponsorship",
      "link": [
        {
          "etichetta": "Partners"
        },
        {
          "etichetta": "Sponsor"
        },
        {
          "etichetta": "Incoming operators"
        },
        {
          "etichetta": "congressual operators"
        },
        {
          "etichetta": "List of suppliers"
        }
      ]
    }
  ]
}
export type HeaderEn = typeof header_en
export const header_fr = {
  "subnav": [
    {
      "etichetta": "Découvrir",
      "link": [
        {
          "etichetta": "À voir, À faire"
        },
        {
          "etichetta": "Événements"
        },
        {
          "etichetta": "Territoire"
        },
        {
          "etichetta": "Où dormir"
        },
        {
          "etichetta": "Où manger"
        },
        {
          "etichetta": "Préparer ton séjour"
        }
      ]
    },
    {
      "etichetta": null,
      "link": [
        {
          "etichetta": null
        },
        {
          "etichetta": null
        },
        {
          "etichetta": null
        },
        {
          "etichetta": null
        },
        {},
        {
          "etichetta": null
        },
        {
          "etichetta": null
        }
      ]
    },
    {
      "etichetta": "Espace Pro",
      "link": [
        {
          "etichetta": "Inspirations"
        },
        {
          "etichetta": "Nous pour vous"
        },
        {
          "etichetta": "Organisez"
        },
        {
          "etichetta": "Transports"
        },
        {
          "etichetta": "Notre Partenaire"
        },
        {
          "etichetta": "Newsletter"
        },
        {
          "etichetta": "Notre équipe"
        }
      ]
    },
    {
      "etichetta": "Écoles",
      "link": [
        {
          "etichetta": "Préparez votre visite"
        },
        {
          "etichetta": "Propositions touristiques"
        },
        {
          "etichetta": "Venir et se déplacer"
        },
        {
          "etichetta": "Hébergements"
        },
        {
          "etichetta": "Où manger"
        },
        {
          "etichetta": "Brochure à telecharger"
        },
        {
          "etichetta": "Nous contacter"
        }
      ]
    },
    {
      "etichetta": "Media",
      "link": [
        {
          "etichetta": null
        },
        {
          "etichetta": "Dossier de presse"
        },
        {
          "etichetta": "Revue de presse"
        },
        {
          "etichetta": "Media"
        }
      ]
    },
    {
      "etichetta": "Partner + Sponsorship",
      "link": [
        {
          "etichetta": "Associés"
        },
        {
          "etichetta": "Sponsor"
        },
        {
          "etichetta": "Opérateurs entrant"
        },
        {
          "etichetta": "Opérateurs congruents"
        },
        {
          "etichetta": "Album des fournisseurs"
        }
      ]
    }
  ]
}
export type HeaderFr = typeof header_fr
export const termini_it = {
  "anno_costruzione": "Anno di costruzione",
  "anno_ristrutturazione": "Anno di ristrutturazione",
  "accordion_tariffe_titolo": "Tariffe",
  "intero": "Intero",
  "ridotto": "Ridotto",
  "gratuito": "Gratuito",
  "famiglie": "Famiglia",
  "scuole": "Scuole",
  "gruppi": "Gruppi",
  "offerta_libera": "Offerta libera",
  "offerta_minima": "Offerta minima",
  "andata_ritorno": "Andata / Ritorno",
  "insegnanti": "Insegnanti",
  "anni_18": "Fino ai 18 anni",
  "anni_1825": "Compreso tra 18 e 25 anni",
  "anni_1925": "Compreso tra 19 e 25 anni",
  "anni_65": "Maggiore di 65 anni",
  "disabili": "Persone con disabilità",
  "accompagnatori": "Accompagnatori di disabili",
  "online": "Acquisti online",
  "acquista": "Acquista ora",
  "prenota": "Prenota ora",
  "accordion_orari_titolo": "Date e Orari",
  "aperture_chiusure_straordinarie": "Aperture/Chiusure straordinarie",
  "aperto": "Aperto",
  "chiuso": "Chiuso",
  "aperto_prenotazione": "Su prenotazione",
  "aperto_eventi": "Aperto solo per eventi",
  "apertura_settimanale": "Apertura settimanale",
  "apertura_mensile": "Apertura mensile",
  "accordion_materiali_scaricabili_titolo": "Materiali scaricabili",
  "ricettivita_categoria_1": "1 stella",
  "ricettivita_categoria_2": "2 stelle",
  "ricettivita_categoria_3": "3 stelle",
  "ricettivita_categoria_4": "4 stelle",
  "ricettivita_categoria_5": "5 stelle",
  "ricettivita_categoria_5L": "5 stelle lusso",
  "accordion_risorse_umane_titolo": "Risorse umane",
  "lingue_parlate_dipendenti": "Lingue parlate dai dipendenti",
  "accordion_spazi_congressuali_titolo": "Spazi congressuali",
  "area_superficie_espositiva": "Area superficie espositiva",
  "mq_expo_aperto": "Area espositiva all'aperto (mq)",
  "mq_expo_coperto": "Area espositiva coperta (mq)",
  "padiglioni": "Numero padiglioni",
  "francese": "Francese",
  "inglese": "Inglese",
  "italiano": "Italiano",
  "sala_stampa": "Sala stampa",
  "servizi": "Servizi",
  "aree_comuni_zona_congressuale": "Aree comuni della zona congressuale (mq)",
  "mq_foyer": "Area accrediti / accreditamento / distribuzione documentazione / foyer",
  "mq_break": "Area per coffee-break",
  "mq_reception": "Area reception",
  "mq_cocktail": "Area cocktail / catering",
  "mq_poster": "Area poster",
  "mq_spazi_polivalenti": "Spazi polivalenti / Area polifunzionale",
  "banco_registrazione": "Banco per la registrazione dei partecipanti",
  "guardaroba_custodito": "Guardaroba custodito",
  "guardaroba_incustodito": "Guardaroba incustodito",
  "magazzino": "Magazzino a disposizione degli organizzatori",
  "spazi_congressuali_interni": "Spazi congressuali a disposizione interni",
  "totale_sale": "Numero totale delle sale",
  "capienza_totale_sale": "Capienza totale delle sale",
  "massimo_posti_sala": "Numero massimo di posti nella sala più capiente",
  "accordion_elenco_sale_titolo": "Elenco sale",
  "totale_posti_a_sedere": "Capienza totale posti a sedere",
  "totale_posti_in_piedi": "Capienza totale posti in piedi",
  "mq_superficie": "Superficie (mq)",
  "m_lunghezza": "Lunghezza (m)",
  "m_larghezza": "Larghezza (m)",
  "m_altezza": "Altezza soffitto (m)",
  "servizi_generici_sala": "Servizi generici sala",
  "attrezzatura_audio": "Attrezzatura audio",
  "attrezzatura_video": "Attrezzatura video",
  "attrezzatura_informatica": "Attrezzatura informatica e telematica",
  "attrezzatura_traduzione": "Attrezzatura per la traduzione simultanea",
  "accesso_internet": "Accesso e postazione internet",
  "wifi": "Wi-Fi",
  "impianto_traduzione_simultanea": "Impianto di traduzione simultanea",
  "numero_cabine_fisse": "Numero cabine fisse",
  "capienza_tavolo_ferro": "Capienza con tavolo a ferro di cavallo",
  "capienza_banchi_scuola": "Capienza con banchi tipo scuola",
  "capienza_teatro": "Capienza a teatro",
  "capienza_tavolo_centrale": "Capienza a tavolo centrale",
  "capienza_tavolo_rotondo": "Capienza a tavoli rotondi",
  "capienza_cocktail": "Capienza a cocktail",
  "totale_posti_tavolo": "Capienza totale posti al tavolo dei relatori",
  "tipo_sedie": "Tipologia sedie",
  "tipo_tavolo": "Tipologia tavolo dei relatori",
  "tipo_sala": "Tipologia sala",
  "sedie_fisse": "Sedie fisse",
  "suddivisibile": "Suddivisibile",
  "non_suddivisibile": "Non suddivisibile",
  "sedie": "Sedie",
  "poltrone": "Poltrone",
  "fisso": "Fisso",
  "asportabile": "Asportabile",
  "accordion_servizi_titolo": "Servizi",
  "coperti_interni": "Coperti interni",
  "coperti_esterni": "Coperti esterni",
  "coperti": "Coperti",
  "posti_dehor": "Posti dehor",
  "posti_eventi": "Posti eventi",
  "posti_terrazza": "Posti terrazza",
  "posti_vista_panoramica": "Posti vista panoramica",
  "sale_riservate": "Numero sale riservate",
  "accordion_cucina_titolo": "La cucina",
  "button_acquista": "Acquista",
  "button_aggiungi_al_carrello": "Aggiungi al carrello",
  "nessuna_convenzione": "Nessuna convenzione",
  "input_nome_intestatario": "Il nome dell'intestatario",
  "input_cognome_intestatario": "Il cognome dell'intestatario",
  "data_di_nascita": "Data di nascita",
  "input_giorno": "Giorno",
  "input_mese": "Mese",
  "input_anno": "Anno",
  "nome": "Nome",
  "cognome": "Cognome",
  "convenzioni": "Convenzioni",
  "tariffa": "Tariffa",
  "mappa": "Mappa",
  "vedi_mappa": "Vedi sulla mappa",
  "nascondi_mappa": "Nascondi mappa",
  "tutte_le_categorie": "Tutte le categorie",
  "tutti_i_comuni": "Tutti i comuni",
  "intorno_a_me": "Intorno a me",
  "oggi": "Oggi",
  "conferma": "Conferma",
  "cerca": "Cerca",
  "tutti_i_target": "Tutti i target",
  "dove_mangiare": "Dove mangiare",
  "dove_dormire": "Dove dormire",
  "offerte": "Proposte",
  "dafarevedere": "Da fare/vedere",
  "inprimopiano": "In primo piano",
  "convention": "Convention",
  "vedi_tutto": "Vedi tutto",
  "load_more": "Carica altri",
  "nessun_risultato": "Nessun risultato",
  "eventi": "Eventi",
  "vedi_tutti_risultati_per": "Vedi tutti i risultati per",
  "anno_costituzione": "Anno di costituzione",
  "pagamenti_accettati": "Pagamenti accettati",
  "lingue_parlate": "Lingue parlate",
  "documento_commerciale": "Documento commerciale",
  "altitudine": "Altitudine",
  "mslm": "mslm",
  "codice_cir": "Codice CIR",
  "scopri_di_piu": "Scopri di più",
  "la_voglio_ora": "La voglio ora!",
  "prodotto_card": "Card",
  "prodotto_esperienza": "Esperienza",
  "prodotto_progetto": "Progetto",
  "prezzo_da": "Da",
  "prezzo_a": "a",
  "prezzo_a_partire_da": "A partire da",
  "prezzo_fino_a": "Fino a",
  "menu_degustazione": "Menù degustazione",
  "menu_sapori_torinesi": "Menù degustazione Sapori Torinesi",
  "menu_gruppi": "Menù per gruppi",
  "menu_bambino": "Menù bambino",
  "menu_business": "Menù business",
  "brunch": "Brunch",
  "menu_turistico": "Menù turistico",
  "menu_famiglia": "Menù famiglia",
  "merenda_sinoira": "Merenda Sinoira",
  "fascia_di_prezzo": "Fascia di prezzo",
  "prezzi": "Prezzi",
  "punto_vendita": "Punto vendita",
  "in_vendita_biglietteria": "In vendita presso la biglietteria",
  "sede_di": "Sede di",
  "responsabile_congressi": "Responsabile congressi",
  "menu_profilo": "Il mio profilo",
  "menu_ordini": "I miei ordini",
  "menu_card": "Le mie card",
  "menu_logout": "Logout",
  "menu_prenotazioni": "Le mie prenotazioni",
  "menu_attivita": "Le mie attività",
  "menu_profilo_desc": "Visualizza e modifica i tuoi dati personali",
  "menu_ordini_desc": "Visualizza tutti i tuoi acquisti",
  "menu_card_desc": "Visualizza e gestisci tutte le tue card",
  "menu_prenotazioni_desc": "Visualizza e gestisci tutte le tue prenotazioni",
  "menu_attivita_desc": "Visualizza o crea nuove attività",
  "intestatario": "Intestatario",
  "scadenza": "Scadenza",
  "visualizza_qr": "Visualizza QR",
  "anni_1217": "Junior 12-17 anni",
  "anni_12": "Under 12",
  "accessori": "Accessori",
  "seleziona_accessori": "Seleziona accessori",
  "evento_parte_di": "Questo evento fa parte di",
  "totale": "Totale",
  "vuoi_regalare_questo_articolo": "Vuoi regalare questo articolo?",
  "indirizzo_email": "Indirizzo email",
  "destinatario": "Destinatario",
  "lingua_preferita": "Lingua preferita",
  "seleziona_lingua": "Seleziona una lingua",
  "data": "Data",
  "alta_stagione": "Alta stagione",
  "bassa_stagione": "Bassa stagione",
  "apertura": "Apertura",
  "accordion_persone_ammesse_titolo": "Persone ammesse",
  "accordion_servizi_attivita_titolo": "Servizi e attività",
  "accordion_dotazioni_titolo": "Dotazioni",
  "accordion_capacita_ricettiva_titolo": "Capacità ricettiva",
  "camere": "Camere",
  "posti_letto": "Posti letto",
  "camere_disabili": "Camere disabili",
  "dotazioni_camera": "Dotazioni camere",
  "dotazioni_comune": "Dotazioni comuni",
  "dotazioni_bagno": "Dotazioni bagni",
  "dotazioni_camere": "Dotazioni camere",
  "ospitalita": "Ospitalità",
  "ristorazione": "Ristorazione",
  "animali": "Animali",
  "colazione": "Colazione",
  "albergo": "Albergo",
  "albergo_diffuso": "Albergo Diffuso",
  "rta": "Residenza Turistico Alberghiera",
  "affittacamere": "Affittacamere",
  "agriturismo": "Agriturismo",
  "bed_and_breakfast": "Bed and Breakfast",
  "campeggio": "Campeggio",
  "villaggio_turistico": "Villaggio Turistico",
  "alloggio_vacanze": "Alloggio Vacanze",
  "casa_vacanze": "Casa Vacanze",
  "casa_ferie": "Casa per Ferie",
  "country_house": "Country House",
  "ostello": "Ostello",
  "bivacco": "Bivacco Fisso",
  "rifugio_alpino": "Rifugio Alpino",
  "rifugio_escursionistico": "Rifugio Escursionistico",
  "rifugio_non_gestito": "Rifugio non gestito",
  "sri": "Strutture Ricettive Innovative",
  "casa_della_giovane": "Casa della giovane",
  "casa_indipendente": "Casa indipendente",
  "casa_religiosa_di_ospitalita": "Casa religiosa di ospitalità",
  "case_indipendenti": "Case indipendenti",
  "cascina": "Cascina",
  "centro_benessere": "Centro benessere",
  "centro_di_soggiorno-studi": "Centro di soggiorno-studi",
  "colonia": "Colonia",
  "condhotel": "Condhotel",
  "condominio": "Condominio",
  "dimora_storica": "Dimora storica",
  "fabbricato_rurale": "Fabbricato rurale",
  "foresteria": "Foresteria",
  "meuble_garni": "Meublé / Garnì",
  "motel": "Motel",
  "ostello_indipendente": "Ostello indipendente",
  "ostello_parte_di_un_circuito": "Ostello parte di un circuito",
  "pensionato_universitario": "Pensionato universitario",
  "rifugio": "Rifugio",
  "villa_a_schiera": "Villa a schiera",
  "villa_indipendente": "Villa indipendente",
  "animali_non_ammessi": "Animali non ammessi",
  "spazio_esterno_per_animali_domestici": "Spazio esterno per animali domestici",
  "animali_ammessi_al_guinzaglio": "Animali ammessi al guinzaglio",
  "pasti_a_cura_della_struttura": "Pasti a cura della struttura",
  "animali_ammessi_in_camera": "Animali ammessi in camera",
  "colazione_non_compresa": "Colazione non compresa",
  "colazione_italiana_compresa": "Colazione italiana compresa",
  "colazione_italiana_a_parte": "Colazione italiana a parte",
  "colazione_inglese_a_parte": "Colazione inglese a parte",
  "colazione_a_buffet_a_parte": "Colazione a buffet a parte",
  "colazione_non_prevista": "Colazione non prevista",
  "prenotazione_obbligatoria": "Prenotazione obbligatoria",
  "visitatori_ammessi": "Visitatori ammessi",
  "studenti_ammessi": "Studenti ammessi",
  "gruppi_ammessi": "Gruppi ammessi",
  "visitatori_non_ammessi": "Visitatori non ammessi",
  "disponibilita_bagni_privati_a_pagamento": "Disponibilità bagni privati a pagamento",
  "struttura_esclusiva_per_naturisti": "Struttura esclusiva per naturisti",
  "servizi_generali": "Servizi generali",
  "uso_singola": "Uso singola",
  "singola": "Singola",
  "singola_senza_bagno": "Singola senza bagno",
  "doppia": "Doppia",
  "doppia_senza_bagno": "Doppia senza bagno",
  "tripla": "Tripla",
  "tripla_senza_bagno": "Tripla senza bagno",
  "quattro_letti": "Quattro letti",
  "quattro_letti_senza_bagno": "Quattro letti senza bagno",
  "suite": "Suite",
  "monolocale": "Monolocale",
  "bilocale": "Bilocale",
  "plurilocale": "Plurilocale",
  "casa": "Casa",
  "1giorno": "1 giorno",
  "1settimana": "1 settimana",
  "2settimane": "2 settimane",
  "1mese": "1 mese",
  "adulti": "Adulti",
  "bambini": "Bambini",
  "auto": "Auto",
  "moto": "Moto",
  "cani": "Cani",
  "mobilhome": "Mobilhome",
  "chalet": "Chalet",
  "bungalow": "Bungalow",
  "bagno": "Con bagno",
  "roulotte": "Roulotte",
  "camper": "Camper",
  "caravan": "Caravan",
  "tenda": "Tenda",
  "piazzola": "Piazzola",
  "camerate": "Camerate",
  "mezza_pensione": "Mezza pensione",
  "pensione_completa": "Pensione completa",
  "letto_in_aggiunta": "Letto in aggiunta",
  "casa_vacanza": "Casa vacanza",
  "ricettivita_categoria_3S": "3 stelle superior",
  "ricettivita_categoria_1sp": "1 spiga",
  "ricettivita_categoria_2sp": "2 spighe",
  "ricettivita_categoria_3sp": "3 spighe",
  "ricettivita_categoria_4sp": "4 spighe",
  "ricettivita_categoria_5sp": "5 spighe",
  "ricettivita_categoria_1g": "1 girasole",
  "ricettivita_categoria_2g": "2 girasoli",
  "ricettivita_categoria_3g": "3 girasoli",
  "ricettivita_categoria_4g": "4 girasoli",
  "ricettivita_categoria_5g": "5 girasoli",
  "sport": "Sport",
  "possessori_carta": "Possessori",
  "error_posizione_lettura": "Non è stato possibile leggere la posizione di questo dispositivo",
  "error_posizione_dispositivo": "Questo dispositivo non è in grado di condividere la propria posizione",
  "data_annullata": "Data annullata",
  "il_cuoco": "Il cuoco",
  "periodo_consigliato": "Periodo consigliato",
  "accordion_informazioni_titolo": "Informazioni",
  "luogo_di_ritrovo": "Luogo di ritrovo",
  "luogo_di_svolgimento": "Luogo di svolgimento",
  "durata": "Durata",
  "modalita_prenotazione": "Modalità di prenotazione",
  "le_sedi": "Le sedi",
  "organizzato_da": "Organizzato da",
  "accompagnatori_di_media_montagna": "Accompagnatori di media montagna",
  "noleggi_attrezzature_sportive": "Noleggi attrezzature sportive",
  "accompagnatori_naturalistici_o_guide_escursionistiche_ambientali": "Guide escursionistiche ambientali",
  "accompagnatori_di_turismo_equestre": "Accompagnatori turismo equestre",
  "organizzazioni_rappresentative_delle_categorie_del_bando": "Organizzazioni outdoor",
  "guide_alpine": "Guide Alpine",
  "accompagnatori_cicloturistici": "Guide cicloturistiche",
  "istruttori_di_canoa_e_kayak": "Istruttori di canoa e kayak",
  "noleggi_biciclette": "Noleggi biciclette",
  "trasporto_bagagli": "Trasporto bagagli e/o biciclette",
  "negozi_di_biciclette": "Negozi di biciclette",
  "negozi_articoli_montagna": "Negozi di articoli sportivi/attrezzatura da montagna",
  "officine_riparazione_biciclette": "Officine riparazione biciclette",
  "aree_geografiche": "Aree geografiche",
  "attivita_proposte": "Attività proposte",
  "attivita_passate": "Attività passate",
  "eventi_correlati": "Eventi correlati",
  "eventi_passati": "Eventi passati",
  "bivacco_fisso": "Bivacco Fisso",
  "casa_per_ferie": "Casa per ferie",
  "nessun_risultato_rircerca": "Nessun risultato per la ricerca",
  "in_questa_categoria": "in questa categoria",
  "prosegui_ricerca": "Prosegui la ricerca",
  "prodotti": "Prodotti",
  "aderenti": "Aderenti",
  "in_vendita_presso": "Dove acquistare?",
  "errore_404": "Pagina non trovata",
  "login_non_ancora_account": "Non hai ancora un account?",
  "login_registrati_qua": "Registrati qui",
  "password": "Password",
  "login_dimenticato_password": "Hai dimenticato la password?",
  "login_accedi": "Accedi",
  "error_manca_email": "Scrivi l'indirizzo email associato al tuo account",
  "error_email_non_valida": "Questo non è un indirizzo email valido",
  "error_manca_password": "Scrivi la tua password",
  "error_login": "L'indirizzo email o la password inseriti non sono corretti.",
  "login_recupera_password": "Recupera password",
  "login_ricevuta_reset": "Richiesta ricevuta: presto riceverai una email con le istruzioni per scegliere una nuova password.",
  "password_dimenticata": "Password dimenticata?",
  "freccia": "Freccia",
  "apri": "Apri",
  "meno_uno": "Meno uno",
  "piu_uno": "Più uno",
  "rimuovi": "Rimuovi",
  "calendario": "Calendario",
  "indietro": "Indietro",
  "avanti": "Avanti",
  "documento": "Documento",
  "telefono": "Telefono",
  "condividi": "Condividi",
  "condividi_su": "Condividi su",
  "carrello": "Carrello",
  "skip_content": "Vai al contenuto",
  "numero_ordine": "№ ordine",
  "ordine_effettuato_il": "Ordine effettuato il",
  "totale_scontato": "Totale scontato",
  "scontato_con_codice": "con codice",
  "accordion_contatti_titolo": "Contatti",
  "data_dal": "dal",
  "data_mdal": "Dal",
  "data_al": "al",
  "data_finoal": "fino al",
  "data_mfinoal": "Fino al",
  "apertura_giornaliera": "Tutti i giorni",
  "operatori_outdoor": "Operatori Outdoor",
  "operatori_incoming": "Operatori Incoming",
  "fornitori_di_trasporto": "Fornitori di trasporto",
  "sport_benessere": "Sport e Benessere",
  "benessere": "Benessere",
  "dotazioni_chalet": "Dotazioni chalet",
  "bagni": "Bagni",
  "stagione_unica": "Stagione unica",
  "altre_informazioni": "Altre informazioni",
  "tipologia": "Tipologia",
  "piscina_scoperta": "Piscina scoperta",
  "golf_numero_buche": "Numero buche",
  "golf_par": "Par",
  "golf_lunghezza_campo": "Lunghezza campo",
  "modifica_profilo": "Modifica il tuo profilo",
  "dettagli_account": "Dettagli dell'account",
  "input_nome": "Il tuo nome",
  "input_cognome": "Il tuo cognome",
  "input_email": "L'email da associare all'account",
  "input_cellulare": "Un tuo numero di telefono",
  "input_provenienza": "La città di provenienza",
  "cellulare": "Numero di cellulare",
  "input_nazione": "Scegli lo stato",
  "citta": "Città",
  "nazione": "Nazione",
  "button_aggiorna_informazioni": "Aggiorna informazioni",
  "modifica_password": "Modifica la password",
  "password_minuscola": "Almeno una lettera minuscola",
  "password_maiuscola": "Almeno una lettera maiuscola",
  "password_numero": "Almeno un numero",
  "password_lunghezza": "Lunga almeno 8 caratteri",
  "input_password_nuova": "La tua nuova password",
  "input_password_ripeti": "Scrivi nuovamente la password",
  "password_confirm": "Ripeti la password",
  "password_criteri": "La password deve rispettare i seguenti criteri:",
  "button_aggiorna_password": "Aggiorna password",
  "nome_required": "Il nome è obbligatorio",
  "cognome_required": "Il cognome è obbligatorio",
  "numero_required": "Il numero è obbligatorio",
  "citta_required": "La città è obbligatoria",
  "nazione_required": "La nazione è obbligatoria",
  "campo_required": "Questo campo è obbligatorio",
  "password_required": "La password è obbligatoria",
  "password_safe": "La password scelta non è abbastanza sicura",
  "confirm_required": "Confermare la password è obbligatorio",
  "confirm_match": "Le password non corrispondono",
  "email_invalid": "Questo non è un indirizzo email valido",
  "email_required": "L'indirizzo email è obbligatorio",
  "email_existing": "Questo indirizzo email è già stato utilizzato",
  "success_modifica_account": "Account modificato con successo",
  "error_modifica_account": "Si è verificato un problema durante la modifica dell'account",
  "success_modifica_password": "Password modificata con successo",
  "error_modifica_password": "Si è verificato un problema durante la modifica della password",
  "promuovi_evento": "Promuovi un evento",
  "promuovi_ristorante": "Promuovi il tuo locale",
  "registrazione_outdoor": "Registrati come Operatore Outdoor",
  "link_utili": "Link utili",
  "ordini_empty": "Gli ordini che effettuerai e i relativi documenti commerciali compariranno qua.",
  "card_empty": "I carnet Armonia e le carte Torino+Piemonte Card e Royal Pass che acquisterai compariranno qua.",
  "prenotazioni_empty": "Le prenotazioni che effettuerai compariranno qua.",
  "dotazioni_bungalow": "Dotazioni bungalow",
  "camere_bungalow": "Camere bungalow",
  "senza_bagno": "Senza bagno",
  "camere_chalet": "Camere chalet",
  "camere_mobilhome": "Camere mobilhome",
  "camere_caravan": "Camere caravan",
  "bungalow_bagno": "Bungalow con bagno",
  "bungalow_senza_bagno": "Bungalow senza bagno",
  "camere_e_suite_bagno": "Camere e suite con bagno",
  "bagni_comuni_disabili": "Bagni comuni disabili",
  "input_email_newsletter": "L'email da iscrivere",
  "input_nome_scuola": "Nome scuola / istituto",
  "input_tipologia_scuola": "Scegli la tipologia di scuola",
  "input_societa": "La tua società",
  "input_interesse": "Scegli un'interesse",
  "input_ruolo": "Ruolo",
  "button_iscriviti": "Iscriviti",
  "scuola": "Scuola",
  "nome_societa": "Nome società",
  "interesse_educational": "Interesse educational",
  "qualifica": "Qualifica",
  "privacy": "Privacy",
  "nessuno": "Nessuno",
  "sci_montagna_invernale": "Sci e Montagna invernale",
  "trekking_estivo": "Trekking estivo",
  "city_break": "City break",
  "newsletter_success": "Iscrizione effettuata con successo",
  "newsletter_error": "Si è verificato un problema durante l'iscrizione alla newsletter",
  "nome_scuola_required": "Il nome dell'istituto è obbligatorio",
  "tipologia_scuola_required": "La tipologia dell'istituto è obbligatoria",
  "societa_required": "Il nome della società è obbligatorio",
  "scuola_primaria": "Primaria",
  "scuola_secondaria_primo_grado": "Secondaria di primo grado",
  "scuola_secondaria_secondo_grado": "Secondaria di secondo grado",
  "privacy_1": "Ho preso visione dell’informativa sul",
  "privacy_2": "trattamento dei dati personali",
  "non_disponibile": "Non disponibile",
  "disponibile_dal": "Disponibile dal",
  "dotazioni_appartamenti": "Dotazioni appartamenti",
  "accordion_raggiungibilita_titolo": "Raggiungibilità",
  "informazioni_generali": "Informazioni generali",
  "minuti_dal_parcheggio": "Minuti a piedi dal parcheggio",
  "veicolo_necessario": "Veicolo necessario",
  "consigliato_fuoristrada": "Consigliato fuoristrada",
  "strada_sterrata": "Strada sterrata",
  "servizio_motoslitta_offerto_dalla_struttura": "Servizio motoslitta offerto dalla struttura",
  "raggiungibile_a_piedi": "Raggiungibile a piedi",
  "raggiungibile_con_sci": "Raggiungibile con sci",
  "strada_asfaltata": "Strada asfaltata",
  "in_isola_pedonale": "In isola pedonale",
  "in_zona_a_traffico_limitato": "In zona a traffico limitato",
  "raggiungibile_con_muli_o_cavalli": "Raggiungibile con muli o cavalli",
  "raggiungibile_con_racchette_da_neve": "Raggiungibile con racchette da neve",
  "sci_alpino": "Sci alpino",
  "sci_fondo": "Sci di fondo",
  "piste_blu": "Piste blu",
  "piste_verdi": "Piste verdi",
  "piste_gialle": "Piste gialle",
  "piste_rosse": "Piste rosse",
  "piste_nere": "Piste nere",
  "piste_totali": "Piste totali",
  "impianti_invernali": "Invernali",
  "impianti_estivi": "Estivi",
  "accordion_impianti_titolo": "Impianti",
  "impianti_totali": "Impianti totali",
  "accordion_attrezzature_titolo": "Attrezzature",
  "dettagli_account_outdoor": "Dettagli del profilo Operatore Outdoor",
  "password_ripeti": "Ripeti la password",
  "avatar": "Immagine del profilo",
  "button_aggiorna_avatar": "Aggiorna avatar",
  "success_modifica_avatar": "Immagine modificata con successo",
  "error_modifica_avatar": "Si è verificato un problema durante la modifica dell'immagine",
  "design": "Design",
  "servizio": "Tour ed Esperienze",
  "pacchetto": "Weekend e Soggiorni",
  "proposte_per_te": "Proposte per te",
  "registrazione_incoming": "Registrati come Operatore Incoming",
  "sito_web": "Sito web",
  "servizi_pacchetti_proposti": "Servizi e pacchetti proposti",
  "menu_pacchetti": "I miei pacchetti e servizi",
  "menu_pacchetti_desc": "Visualizza o crea nuovi pacchetti o servizi",
  "tour_operator_incoming": "Tour operator incoming",
  "fornitori_servizi_turistici_singoli": "Fornitori servizi turistici singoli",
  "consorzi_alberghieri": "Consorzi alberghieri",
  "fornitori_servizi_trasporto": "Fornitori servizi trasporto",
  "credits_progetto": "Progetto:",
  "credits_web": "Sviluppo web:",
  "fee_prenotazione": "Servizio di prenotazione",
  "chiusura_biglietteria": "Chiusura biglietteria",
  "gestisci": "Gestisci",
  "prenota_spettacoli": "Prenota spettacoli",
  "card_abbonamenti": "Torino+Piemonte Card e Royal Pass",
  "codice_non_disponibile": "Codice non disponibile",
  "abbonamento_informazioni": "Informazioni",
  "abbonamento_cancellazione": "Cancellazione",
  "abbonamento_non_trovato": "Card non trovata",
  "prenota_visita_guidata": "Prenota una visita guidata",
  "seleziona_data": "Seleziona la data",
  "button_aggiungi_posto": "Aggiungi posto",
  "visita_guidata_non_trovata": "Visita guidata non trovata",
  "data_disponibile_singolare": "data disponibile",
  "data_disponibile_plurale": "date disponibili",
  "posto_disponibile_singolare": "Ultimo posto disponible per questa data",
  "posto_disponibile_plurale": "posti disponibili per questa data",
  "error_manca_lingua": "Devi selezionare una lingua",
  "error_carrello_prenotazione": "Si è verificato un problema durante l'aggiunta al carrello di questa prenotazione",
  "disabled_data_annullata": "data annullata",
  "disabled_posti_esauriti": "Posti esauriti",
  "disabled_posti_non_disponibili": "posti non disponibili",
  "disabled_prenotabile_da_data": "prenotabile dal",
  "input_categoria": "Scegli una categoria",
  "input_codice_promozionale": "Codice promozionale",
  "carrello_vuoto": "Il tuo carrello è vuoto",
  "error_codice_promozionale_troppo_presto": "Il codice inserito non è ancora valido",
  "error_codice_promozionale_troppo_tardi": "Il codice inserito non è più valido",
  "error_codice_promozionale_usato": "Il codice inserito è già stato utilizzato",
  "error_codice_promozionale_inesistente": "Il codice inserito non è valido",
  "error_codice_promozionale_server": "Non è stato possibile verificare la validità di questo codice",
  "error_manca_email_destinatario": "L'indirizzo del destinatario è obbligatorio",
  "error_autoregalo": "Scegli l'indirizzo di un'altra persona a cui regalare questo articolo",
  "crea_account": "Crea un nuovo account",
  "input_email_confim": "Scrivi nuovamente l'email",
  "indirizzo_email_confirm": "Ripeti l'email",
  "input_password": "La password da associare all'account",
  "preferenza_lingua": "Lingua preferita per comunicazioni",
  "input_preferenza_lingua": "Scegli una lingua",
  "button_registrati": "Registrati",
  "gia_registrato": "Sei già registrato?",
  "gia_registrato_accedi": "Accedi",
  "gia_registrato_area": "alla tua area riservata.",
  "privacy_1b": "Ho preso visione delle",
  "privacy_2b": "Condizioni d'acquisto",
  "email_confirm_required": "Confermare l'indirizzo email è obbligatorio",
  "email_confirm_match": "Gli indirizzi email non corrispondono",
  "preferenza_lingua_required": "La lingua di preferenza è obbligatoria",
  "success_creazione_account": "Registrazione effettuata con successo",
  "button_prosegui": "Prosegui",
  "button_accedi": "Accedi",
  "error_creazione_account": "Si è verificato un problema durante la registrazione",
  "carrello_vuoto_sottotitolo": "Scopri come rendere unico il tuo soggiorno con le nostre proposte",
  "carrello_pieno": "Hai messo tutto nel carrello?",
  "carrello_pieno_sottotitolo": "Prima di procedere con l'acquisto, scopri le altre esperienze che possono rendere unico il tuo soggiorno!",
  "button_accetta": "Accetta",
  "error_accettazione_regalo": "Si è verificato un problema durante l'accettazione del regalo",
  "notifica_carnet_regalato": "ti ha regalato il carnet",
  "notifica_carnet_associazione_1": "vuole associare il carnet",
  "notifica_carnet_associazione_2": "al suo account",
  "parziale_lordo": "parziale lordo",
  "validita": "Validità",
  "disponibilita_posti": "Disponibilità posti",
  "scaduta": "scaduta",
  "fino_al": "fino al",
  "button_paga": "Paga",
  "carrello_acquista": "Acquista",
  "error_checkout_prodotto": "Uno dei prodotti nel tuo carrello non è più acquistabile",
  "error_checkout_stock": "Uno dei prodotti nel tuo carrello supera la quantità acquistabile al momento",
  "error_checkout_generico": "Si è verificato un problema durante la preparazione del checkout, ti preghiamo di riprovare più tardi",
  "error_pagamento": "Si è verificato un problema durante il pagamento",
  "error_pagamento_creazione": "Si è verificato un problema durante la creazione del pagamento",
  "km_da": "Km da",
  "km_da_te": "te",
  "prenota_spettacolo": "Prenota uno spettacolo",
  "website": "Sito Web",
  "abbonamento_musei": "Abbonamento Musei",
  "data_di_nascita_required": "La data di nascita è obbligatoria",
  "error_data_di_nascita_non_valida": "La data di nascita non è valida",
  "error_data_di_nascita_min": "Devi avere almeno",
  "error_data_di_nascita_max": "Devi avere al massimo",
  "error_data_di_nascita_anni": "anni di età",
  "tariffa_required": "La tariffa è obbligatoria",
  "error_carrello_prodotto": "Si è verificato un problema durante l'aggiunta al carrello di questo prodotto",
  "input_cap": "Il tuo CAP",
  "input_indirizzo": "Il tuo indirizzo",
  "input_codice": "Codice",
  "input_ragione_sociale": "Nome",
  "input_sede_legale_piva_cf": "Codice della sede legale",
  "input_sede_legale_nazione": "Scegli lo stato della sede legale",
  "input_sede_legale_indirizzo": "Indirizzo della sede legale",
  "input_sede_legale_cap": "CAP della sede legale",
  "input_sede_legale_citta": "La città della sede legale",
  "input_sede_legale_cellulare": "Numero della sede legale",
  "input_sede_legale_email": "Indirizzo della sede legale",
  "button_modifica": "Modifica",
  "crea_nuova_password": "Crea una nuova password",
  "error_crea_nuova_password": "Non è stato possibile modificare la password. Questo collegamento potrebbe essere scaduto o non corretto, richiedine uno nuovo.",
  "button_nuovo_collegamento": "Richiedi nuovo collegamento",
  "button_vai_login": "Vai al login",
  "crea_account_regalo": "Crea un account per usufruire del tuo regalo",
  "termini_condizioni": "Termini e condizioni",
  "anni_011": "Bambini 0-11 anni",
  "modifica_consenso_cookie": "Modifica consenso Cookie",
  "dontmiss_descrizione": "Esistono luoghi meravigliosi da visitare, di cui godere e innamorarsi.",
  "dontmiss_input": "Cerca l'attrazione",
  "button_posti_esauriti": "Posti esauriti",
  "login": "Login",
  "login_sottotitolo_1": "Stiamo rinnovando il nostro sito per offrirti un'esperienza sempre più piacevole.",
  "login_sottotitolo_2": "Se eri iscritto alla versione precedente del sito dovrai effettuare una nuova registrazione",
  "login_sottotitolo_qui": "qui",
  "login_sottotitolo_3": "Per informazioni o altri dettagli relativi ai tuoi acquisti effettuati prima del 5 novembre puoi inviare una mail all'indirizzo",
  "checkout_grazie": "Grazie per l'acquisto",
  "annullato": "Annullato",
  "input_cerca_evento": "Nome dell'evento",
  "tutti_tipi_strutture": "Tutti i tipi di struttura",
  "input_tipo_struttura": "Tipo di struttura",
  "input_luogo": "Luogo (città)",
  "input_cerca_locale": "Nome del locale",
  "proposte_tour": "Tour ed Esperienze",
  "proposte_weekend": "Weekend e Soggiorni",
  "proposte_outdoor": "Esperienze outdoor",
  "tutte_le_proposte": "Tutte le proposte",
  "aderisce_a": "Aderisce a",
  "nessuna_selezione": "Nessuna selezione",
  "checkbox_newsletter": "Acconsento al trattamento dei miei dati personali per ricevere comunicazioni commerciali e/o promozionali tramite la newsletter di Turismo Torino e Provincia.",
  "input_telefono": "Numero di telefono",
  "dettagli_account_incoming": "Dettagli del profilo Operatore Incoming",
  "tutte_le_tipologie_eventi": "Tutti i tipi di evento",
  "nessun_risultato_prova_giorni": "Nessun risultato: prova selezionando più giorni",
  "nessun_risultato_prova_proposte": "Nessun risultato: prova cercando fra tutte le proposte",
  "concluso": "Concluso",
  "aperto_visite_guidate": "Solo visite guidate",
  "posto": "POSTO",
  "posti": "POSTI",
  "la_proposta_comprende": "La proposta comprende",
  "proposte_turistiche": "Proposte turistiche",
  "acquista_altra_tpc": "Vuoi acquistarne un'altra?",
  "acquista_altra_rp": "Vuoi acquistarne un altro?",
  "privacy_3b": "e dell'",
  "privacy_4b": "Informativa sulla Privacy",
  "error_caricamento_avatar": "Si è verificato un problema durante il caricamento dell'immagine",
  "error_immagine_troppo_grande": "L'immagine caricata è troppo grande",
  "error_formato_immagine": "Il formato dell'immagine non è valido",
  "error_aggiornamento_avatar": "Si è verificato un problema durante l'aggiornamento dell'avatar",
  "dati_non_pervenuti": "Dati non pervenuti",
  "chiusura_temporanea": "Chiusura temporanea",
  "suspended": "Oggi non disponibile",
  "error_checkout_sconto": "Si è verificato un errore durante l'applicazione dello sconto. Ti preghiamo di segnalarci il problema o di riprovare più tardi.",
  "input_cerca_operatore": "Nome dell'operatore",
  "durata_visita": "Durata della visita",
  "visita_media": "Visita media",
  "visita_famiglia": "Visita famiglia",
  "meno_1h": "Meno di 1 ora",
  "1h_2h": "Da 1 a 2 ore",
  "2h_3h": "Da 2 a 3 ore",
  "oltre_3h": "Oltre 3 ore",
  "menu_locali": "Il mio locale",
  "menu_locali_desc": "Visualizza e gestisci il tuo locale",
  "evento_in_combinazione": "Questo evento è disponibile in combinazione con",
  "visita_singola": "Visita singola",
  "tariffa_combinata": "Tariffa combinata",
  "button_applica_coupon": "Applica coupon"
}
export type TerminiIt = typeof termini_it
export const termini_en = {
  "anno_costruzione": "Year of construction",
  "anno_ristrutturazione": "Year of renovation",
  "accordion_tariffe_titolo": "Admissions",
  "intero": "Full Ticket",
  "ridotto": "Reduced",
  "gratuito": "Free",
  "famiglie": "Family",
  "scuole": "Schools",
  "gruppi": "Groups",
  "offerta_libera": "Donation",
  "offerta_minima": "Minimum offer",
  "andata_ritorno": "Return",
  "insegnanti": "Teachers",
  "anni_18": "Up to 18 years old",
  "anni_1825": "From 18 to 25 years old",
  "anni_1925": "From 19 to 25 years old",
  "anni_65": "Over 65 years old",
  "disabili": "People with disabilities",
  "accompagnatori": "Accompanying people with disabilities",
  "online": "Online purchases",
  "acquista": "Buy now",
  "prenota": "Book now",
  "accordion_orari_titolo": "Timetables",
  "aperture_chiusure_straordinarie": "Extraordinary openings/closures",
  "aperto": "Open",
  "chiuso": "Closed",
  "aperto_prenotazione": "Upon reservation",
  "aperto_eventi": "Open for events only",
  "apertura_settimanale": "Weekly opening",
  "apertura_mensile": "Monthly opening",
  "accordion_materiali_scaricabili_titolo": "Downloads",
  "ricettivita_categoria_1": "1 star",
  "ricettivita_categoria_2": "2 stars",
  "ricettivita_categoria_3": "3 stars",
  "ricettivita_categoria_4": "4 stars",
  "ricettivita_categoria_5": "5 stars",
  "ricettivita_categoria_5L": "5-stars luxury",
  "accordion_risorse_umane_titolo": "Human resources",
  "lingue_parlate_dipendenti": "Languages spoken by employees",
  "accordion_spazi_congressuali_titolo": "Conference Venues",
  "area_superficie_espositiva": "Display area",
  "mq_expo_aperto": "Outdoor display area (sqm)",
  "mq_expo_coperto": "Covered display area (sqm)",
  "padiglioni": "stand number",
  "francese": "French",
  "inglese": "English",
  "italiano": "Italian",
  "sala_stampa": "Press room",
  "servizi": "Services",
  "aree_comuni_zona_congressuale": "Common areas of the conference venue (sqm)",
  "mq_foyer": "Accreditation / accreditation area / documents distribution / foyer",
  "mq_break": "Coffee-break area",
  "mq_reception": "Reception area",
  "mq_cocktail": "Cocktail area/ catering area",
  "mq_poster": "Poster area",
  "mq_spazi_polivalenti": "Multipurpose spaces / Multifunctional area",
  "banco_registrazione": "Counter for registering participants",
  "guardaroba_custodito": "Guarded cloakroom",
  "guardaroba_incustodito": "Unattended cloakroom",
  "magazzino": "Warehouse available to organisers",
  "spazi_congressuali_interni": "Interior conference areas available",
  "totale_sale": "Total number of rooms",
  "capienza_totale_sale": "Total room capacity",
  "massimo_posti_sala": "Maximum number of seats in the largest room",
  "accordion_elenco_sale_titolo": "List of rooms",
  "totale_posti_a_sedere": "Total seating capacity",
  "totale_posti_in_piedi": "Total standing  capacity",
  "mq_superficie": "Surface area (m²)",
  "m_lunghezza": "Length (m)",
  "m_larghezza": "Width (m)",
  "m_altezza": "Ceiling height (m)",
  "servizi_generici_sala": "Generic room services",
  "attrezzatura_audio": "Audio equipment",
  "attrezzatura_video": "Video equipment",
  "attrezzatura_informatica": "Computer and telematics equipment",
  "attrezzatura_traduzione": "Simultaneous translation equipment",
  "accesso_internet": "Internet point ",
  "wifi": "Wi-Fi",
  "impianto_traduzione_simultanea": "Simultaneous translation facility",
  "numero_cabine_fisse": "Number of fixed booths",
  "capienza_tavolo_ferro": "Capacity u-shaped table",
  "capienza_banchi_scuola": "Capacity with school-type desks",
  "capienza_teatro": "Theatre capacity",
  "capienza_tavolo_centrale": "Centre table capacity",
  "capienza_tavolo_rotondo": "Round table capacity",
  "capienza_cocktail": "Cocktail capacity",
  "totale_posti_tavolo": "Total seating capacity at the speakers' table",
  "tipo_sedie": "Chairs type",
  "tipo_tavolo": "Speaker table type",
  "tipo_sala": "Room type",
  "sedie_fisse": "Fixed chairs",
  "suddivisibile": "Divisible",
  "non_suddivisibile": "Non-divisible",
  "sedie": "Chairs",
  "poltrone": "Armchairs",
  "fisso": "Fixed",
  "asportabile": "Removable",
  "accordion_servizi_titolo": "Services",
  "coperti_interni": "Indoor covers",
  "coperti_esterni": "Outdoor covers",
  "coperti": "Covers",
  "posti_dehor": "Places dehor",
  "posti_eventi": "Event Places",
  "posti_terrazza": "Terrace Places",
  "posti_vista_panoramica": "Places overview",
  "sale_riservate": "Number of reserved rooms",
  "accordion_cucina_titolo": "The kitchen",
  "button_acquista": "Buy",
  "button_aggiungi_al_carrello": "Add to basket",
  "nessuna_convenzione": "No convention",
  "input_nome_intestatario": "The name of the holder",
  "input_cognome_intestatario": "The surname of the holder",
  "data_di_nascita": "Date of birth",
  "input_giorno": "Day",
  "input_mese": "Month",
  "input_anno": "Year",
  "nome": "Name",
  "cognome": "Surname",
  "convenzioni": "Reduced price",
  "tariffa": "Price",
  "mappa": "Map",
  "vedi_mappa": "View map",
  "nascondi_mappa": "Hide map",
  "tutte_le_categorie": "Any category",
  "tutti_i_comuni": "Any municipality",
  "intorno_a_me": "Around me",
  "oggi": "Today",
  "conferma": "Apply",
  "cerca": "Search",
  "tutti_i_target": "Any target",
  "dove_mangiare": "Where to eat",
  "dove_dormire": "Accomodation",
  "offerte": "Offers",
  "dafarevedere": "Things to do/see",
  "inprimopiano": "Highlights",
  "convention": "Convention",
  "vedi_tutto": "See all",
  "load_more": "Load more",
  "nessun_risultato": "No results",
  "eventi": "Events",
  "vedi_tutti_risultati_per": "See all results for",
  "anno_costituzione": "Year of establishment",
  "pagamenti_accettati": "Accepted payments",
  "lingue_parlate": "Languages spoken",
  "documento_commerciale": "Business document",
  "altitudine": "Altitude",
  "mslm": "mslm",
  "codice_cir": "CIR Code",
  "scopri_di_piu": "Find out more",
  "la_voglio_ora": "I want it now!",
  "prodotto_card": "Card",
  "prodotto_esperienza": "Experience",
  "prodotto_progetto": "Project",
  "prezzo_da": "From",
  "prezzo_a": "to",
  "prezzo_a_partire_da": "Starting from",
  "prezzo_fino_a": "Up to",
  "menu_degustazione": "Tasting menu",
  "menu_sapori_torinesi": "Tasting menu Sapori Torinesi",
  "menu_gruppi": "Menus for groups",
  "menu_bambino": "Children menu",
  "menu_business": "Business menu",
  "brunch": "Brunch",
  "menu_turistico": "Tourist menu",
  "menu_famiglia": "Family menu",
  "merenda_sinoira": "Merenda Sinoira",
  "fascia_di_prezzo": "Price range",
  "prezzi": "Prices",
  "punto_vendita": "Point of sale",
  "in_vendita_biglietteria": "On sale at the ticket office",
  "sede_di": "It houses",
  "responsabile_congressi": "Conference manager",
  "menu_profilo": "My Profile",
  "menu_ordini": "My orders",
  "menu_card": "My Cards",
  "menu_logout": "Logout",
  "menu_prenotazioni": "My Reservations",
  "menu_attivita": "My Activities",
  "menu_profilo_desc": "View and edit your personal data",
  "menu_ordini_desc": "View all your purchases",
  "menu_card_desc": "View and manage all your cards",
  "menu_prenotazioni_desc": "View and manage all your bookings",
  "menu_attivita_desc": "View or create new activities",
  "intestatario": "Header",
  "scadenza": "Deadline",
  "visualizza_qr": "Display QR",
  "anni_1217": "Junior 12-17 years old",
  "anni_12": "Under 12",
  "accessori": "Accessories",
  "seleziona_accessori": "Select accessories",
  "evento_parte_di": "This event is part of",
  "totale": "Total",
  "vuoi_regalare_questo_articolo": "Would you like to gift this item?",
  "indirizzo_email": "Email address",
  "destinatario": "Recipient",
  "lingua_preferita": "Favorite language",
  "seleziona_lingua": "Select a language",
  "data": "Date",
  "alta_stagione": "High season",
  "bassa_stagione": "Low season",
  "apertura": "Opening",
  "accordion_persone_ammesse_titolo": "Authorized people",
  "accordion_servizi_attivita_titolo": "Services and activities",
  "accordion_dotazioni_titolo": "Equipment",
  "accordion_capacita_ricettiva_titolo": "Accomodation capacity",
  "camere": "Rooms",
  "posti_letto": "Beds",
  "camere_disabili": "Disabled rooms",
  "dotazioni_camera": "Room facilities",
  "dotazioni_comune": "Common equipment",
  "dotazioni_bagno": "Bathroom facilities",
  "dotazioni_camere": "Room facilities",
  "ospitalita": "Hospitality",
  "ristorazione": "Catering",
  "animali": "Animals",
  "colazione": "Breakfast",
  "albergo": "Hotel",
  "albergo_diffuso": "Scattered Hotel",
  "rta": "Tourist Residence",
  "affittacamere": "Renting",
  "agriturismo": "Farmhouse",
  "bed_and_breakfast": "Bed and Breakfast",
  "campeggio": "Camping",
  "villaggio_turistico": "Holiday Village",
  "alloggio_vacanze": "Holiday Accommodation",
  "casa_vacanze": "Holiday Home",
  "casa_ferie": "Holiday Home",
  "country_house": "Country House",
  "ostello": "Hostel",
  "bivacco": "Fixed Bivouac",
  "rifugio_alpino": "Alpine Shelter",
  "rifugio_escursionistico": "Hiking Shelter",
  "rifugio_non_gestito": "Unmanaged Shelter",
  "sri": "Innovative Hospitality Facilities",
  "casa_della_giovane": "Home for  young women",
  "casa_indipendente": "Detached house",
  "casa_religiosa_di_ospitalita": "Religious house of hospitality",
  "case_indipendenti": "Independent houses",
  "cascina": "Farm",
  "centro_benessere": "Wellness Centre",
  "centro_di_soggiorno-studi": "Stay-Study Centre",
  "colonia": "Camp",
  "condhotel": "Condhotel",
  "condominio": "Apartment building",
  "dimora_storica": "Historic house",
  "fabbricato_rurale": "Rural building",
  "foresteria": "Guesthouse",
  "meuble_garni": "Meublé / Garnì",
  "motel": "Motel",
  "ostello_indipendente": "Independent hostel",
  "ostello_parte_di_un_circuito": "Hostel belonging to a network",
  "pensionato_universitario": "University boarding house",
  "rifugio": "Refuge",
  "villa_a_schiera": "Terraced house",
  "villa_indipendente": "Independent villa",
  "animali_non_ammessi": "No pets allowed",
  "spazio_esterno_per_animali_domestici": "Outdoor space for pets",
  "animali_ammessi_al_guinzaglio": "Animals allowed on a leash",
  "pasti_a_cura_della_struttura": "Meals provided by the facility",
  "animali_ammessi_in_camera": "Pets allowed in the room",
  "colazione_non_compresa": "Breakfast not included",
  "colazione_italiana_compresa": "Italian breakfast included",
  "colazione_italiana_a_parte": "Italian breakfast not included",
  "colazione_inglese_a_parte": "English breakfast not included",
  "colazione_a_buffet_a_parte": "Buffet breakfast not included",
  "colazione_non_prevista": "Breakfast not included",
  "prenotazione_obbligatoria": "Compulsory booking",
  "visitatori_ammessi": "Visitors admitted",
  "studenti_ammessi": "Students admitted ",
  "gruppi_ammessi": "Groups admitted",
  "visitatori_non_ammessi": "Visitors are not admitted",
  "disponibilita_bagni_privati_a_pagamento": "Private toilets available at a cost",
  "struttura_esclusiva_per_naturisti": "Facility reserved for naturists",
  "servizi_generali": "General services",
  "uso_singola": "Double room for one person only",
  "singola": "Single room",
  "singola_senza_bagno": "Single room without bathroom",
  "doppia": "Double room",
  "doppia_senza_bagno": "Double room without bathroom",
  "tripla": "Triple room",
  "tripla_senza_bagno": "Triple room without bathroom",
  "quattro_letti": "Four beds",
  "quattro_letti_senza_bagno": "Four beds room without bathroom",
  "suite": "Suite",
  "monolocale": "Studio",
  "bilocale": "Two-rooms",
  "plurilocale": "multi-room",
  "casa": "Home",
  "1giorno": "1 day",
  "1settimana": "1 week",
  "2settimane": "2 weeks",
  "1mese": "1 month",
  "adulti": "Adults",
  "bambini": "Children",
  "auto": "Car",
  "moto": "Moto",
  "cani": "Dogs",
  "mobilhome": "Mobilhome",
  "chalet": "Chalet",
  "bungalow": "Bungalow",
  "bagno": "Ensuite",
  "roulotte": "Caravans",
  "camper": "Camper",
  "caravan": "Caravan",
  "tenda": "Tent",
  "piazzola": "Pitch",
  "camerate": "Dormitory",
  "mezza_pensione": "Half Board",
  "pensione_completa": "Full board",
  "letto_in_aggiunta": "Extra bed",
  "casa_vacanza": "Holiday home",
  "ricettivita_categoria_3S": "3 stars superior",
  "ricettivita_categoria_1sp": "1 spike",
  "ricettivita_categoria_2sp": "2 spikes",
  "ricettivita_categoria_3sp": "3 spikes",
  "ricettivita_categoria_4sp": "4 spikes",
  "ricettivita_categoria_5sp": "5 spikes",
  "ricettivita_categoria_1g": "1 sunflower",
  "ricettivita_categoria_2g": "2 sunflowers",
  "ricettivita_categoria_3g": "3 sunflowers",
  "ricettivita_categoria_4g": "4 sunflowers",
  "ricettivita_categoria_5g": "5 sunflowers",
  "sport": "Sport",
  "possessori_carta": "Holders",
  "error_posizione_lettura": "The location of this device could not be read",
  "error_posizione_dispositivo": "This device is not able to share its location",
  "data_annullata": "Cancelled date",
  "il_cuoco": "The cook",
  "periodo_consigliato": "Recommended period",
  "accordion_informazioni_titolo": "Information",
  "luogo_di_ritrovo": "Meeting place",
  "luogo_di_svolgimento": "Where it takes place",
  "durata": "Duration",
  "modalita_prenotazione": "How to book",
  "le_sedi": "The venues",
  "organizzato_da": "Organised by",
  "accompagnatori_di_media_montagna": "Medium-Altitude Mountain Guides",
  "noleggi_attrezzature_sportive": "Sports equipment rentals",
  "accompagnatori_naturalistici_o_guide_escursionistiche_ambientali": "Enviromental  hiking guides",
  "accompagnatori_di_turismo_equestre": "Equestrian tourism guides",
  "organizzazioni_rappresentative_delle_categorie_del_bando": "Outoor organisations",
  "guide_alpine": "Alpine Guides",
  "accompagnatori_cicloturistici": "Bicycle Tour Guides",
  "istruttori_di_canoa_e_kayak": "Canoe and kayak instructors",
  "noleggi_biciclette": "Bicycle rentals",
  "trasporto_bagagli": "Luggage and bicycle transport",
  "negozi_di_biciclette": "Bicycle shops",
  "negozi_articoli_montagna": "Sports/mountain equipment shops",
  "officine_riparazione_biciclette": "Bicycle repair shops",
  "aree_geografiche": "Geographical areas",
  "attivita_proposte": "Proposed activities",
  "attivita_passate": "Past activities",
  "eventi_correlati": "Related events",
  "eventi_passati": "Past events",
  "bivacco_fisso": "Fixed Bivouac",
  "casa_per_ferie": "Holiday home",
  "nessun_risultato_rircerca": "No search results",
  "in_questa_categoria": "in this category",
  "prosegui_ricerca": "Continue the search",
  "prodotti": "Products",
  "aderenti": "Attendees",
  "in_vendita_presso": "Where to buy?",
  "errore_404": "Page not found",
  "login_non_ancora_account": "Don't have an account yet?",
  "login_registrati_qua": "Create new account",
  "password": "Password",
  "login_dimenticato_password": "Forgot your password?",
  "login_accedi": "Login",
  "error_manca_email": "Type in the email address associated with your account",
  "error_email_non_valida": "This is not a valid email address",
  "error_manca_password": "Write your password",
  "error_login": "The e-mail address or password entered is incorrect.",
  "login_recupera_password": "Password recovery",
  "login_ricevuta_reset": "Request received: you will soon receive an email with instructions on how to select a new password.",
  "password_dimenticata": "Have you forgot your password?",
  "freccia": "Arrow",
  "apri": "Open",
  "meno_uno": "Minus one",
  "piu_uno": "Plus one",
  "rimuovi": "Remove",
  "calendario": "Calendar",
  "indietro": "Back",
  "avanti": "Next",
  "documento": "Document",
  "telefono": "Telephone",
  "condividi": "Share",
  "condividi_su": "Share on",
  "carrello": "Shopping Cart",
  "skip_content": "Go to content",
  "numero_ordine": "№ order",
  "ordine_effettuato_il": "Order made the",
  "totale_scontato": "Discounted total",
  "scontato_con_codice": "with code",
  "accordion_contatti_titolo": "Contacts",
  "data_dal": "from",
  "data_mdal": "From",
  "data_al": "to",
  "data_finoal": "up to",
  "data_mfinoal": "Up to",
  "apertura_giornaliera": "Everyday",
  "operatori_outdoor": "Outdoor Operators",
  "operatori_incoming": "Incoming Operators",
  "fornitori_di_trasporto": "Transport providers",
  "sport_benessere": "Sport and Wellness",
  "benessere": "Well-being",
  "dotazioni_chalet": "Chalet equipment",
  "bagni": "Bathrooms",
  "stagione_unica": "Single season",
  "altre_informazioni": "Other information",
  "tipologia": "Typology",
  "piscina_scoperta": "Outdoor pool",
  "golf_numero_buche": "Number of holes",
  "golf_par": "Par",
  "golf_lunghezza_campo": "Field length",
  "modifica_profilo": "Edit your profile",
  "dettagli_account": "Account details",
  "input_nome": "Your name",
  "input_cognome": "Your surname",
  "input_email": "The email to be associated with the account",
  "input_cellulare": "Your telephone number",
  "input_provenienza": "The city of origin",
  "cellulare": "Mobile phone number",
  "input_nazione": "Choose state",
  "citta": "City",
  "nazione": "Country",
  "button_aggiorna_informazioni": "Update information",
  "modifica_password": "Change Password",
  "password_minuscola": "At least one lower case letter",
  "password_maiuscola": "At least one capital letter",
  "password_numero": "At least one number",
  "password_lunghezza": "at least 8 characters long",
  "input_password_nuova": "Your new password",
  "input_password_ripeti": "confirm password",
  "password_confirm": "Repeat password",
  "password_criteri": "The password must comply with the following criteria",
  "button_aggiorna_password": "Update Password",
  "nome_required": "The name is mandatory",
  "cognome_required": "The surname is mandatory",
  "numero_required": "The number is mandatory",
  "citta_required": "The city is mandatory",
  "nazione_required": "The country is mandatory",
  "campo_required": "This field is mandatory",
  "password_required": "The password is mandatory",
  "password_safe": "The chosen password is not secure enough",
  "confirm_required": "Confirming the password is mandatory",
  "confirm_match": "Passwords do not match",
  "email_invalid": "This is not a valid email address",
  "email_required": "Email address is mandatory",
  "email_existing": "This email address has already been used",
  "success_modifica_account": "Account successfully edited",
  "error_modifica_account": "A problem occurred while editing the account",
  "success_modifica_password": "Password successfully changed",
  "error_modifica_password": "A problem occurred while changing the password",
  "promuovi_evento": "Promote an event",
  "promuovi_ristorante": "Promote a restaurant",
  "registrazione_outdoor": "Register as Outdoor Operator",
  "link_utili": "Useful links",
  "ordini_empty": "The orders you place and the related commercial documents will appear here.",
  "card_empty": "The Armonia carnets and the Torino+Piemonte Card and Royal Pass cards you purchase will appear here.",
  "prenotazioni_empty": "The bookings you make will appear here.",
  "dotazioni_bungalow": "Bungalow equipment",
  "camere_bungalow": "Bungalow rooms",
  "senza_bagno": "Without bathroom",
  "camere_chalet": "Chalet rooms",
  "camere_mobilhome": "Mobile home rooms",
  "camere_caravan": "Caravan rooms",
  "bungalow_bagno": "Bungalow with bathroom",
  "bungalow_senza_bagno": "Bungalow without bathroom",
  "camere_e_suite_bagno": "Rooms and suites with bathroom",
  "bagni_comuni_disabili": "Common disabled toilets",
  "input_email_newsletter": "The email to subscribe",
  "input_nome_scuola": "School/institution name",
  "input_tipologia_scuola": "Choose school type",
  "input_societa": "Your company",
  "input_interesse": "Choose an interest",
  "input_ruolo": "Role",
  "button_iscriviti": "Sign up",
  "scuola": "School",
  "nome_societa": "Company name",
  "interesse_educational": "Educational interest",
  "qualifica": "Qualification",
  "privacy": "Privacy",
  "nessuno": "None",
  "sci_montagna_invernale": "Skiing and Winter Mountain",
  "trekking_estivo": "Summer hiking",
  "city_break": "City break",
  "newsletter_success": "Registration confirmed",
  "newsletter_error": "A problem occurred when subscribing to the newsletter",
  "nome_scuola_required": "The name of the institution is mandatory",
  "tipologia_scuola_required": "The typology of the institution is mandatory",
  "societa_required": "The company name is mandatory",
  "scuola_primaria": "Primary",
  "scuola_secondaria_primo_grado": "Secondary",
  "scuola_secondaria_secondo_grado": "Secondary",
  "privacy_1": "I have read the",
  "privacy_2": "processing of personal data",
  "non_disponibile": "Not available",
  "disponibile_dal": "Available from",
  "dotazioni_appartamenti": "Flat facilities",
  "accordion_raggiungibilita_titolo": "Accessibility",
  "informazioni_generali": "General Information",
  "minuti_dal_parcheggio": "Minutes' walk from the car park",
  "veicolo_necessario": "Vehicle needed",
  "consigliato_fuoristrada": "Recommended off-road",
  "strada_sterrata": "Dirt road",
  "servizio_motoslitta_offerto_dalla_struttura": "Snowmobile service offered by the facility",
  "raggiungibile_a_piedi": "Reachable on foot",
  "raggiungibile_con_sci": "Accessible by ski",
  "strada_asfaltata": "Paved road",
  "in_isola_pedonale": "In the pedestrian area",
  "in_zona_a_traffico_limitato": "In a restricted traffic zone",
  "raggiungibile_con_muli_o_cavalli": "Accessible with mules or horses",
  "raggiungibile_con_racchette_da_neve": "Accessible with snowshoes",
  "sci_alpino": "Alpine skiing",
  "sci_fondo": "Cross-country skiing",
  "piste_blu": "Blue slopes",
  "piste_verdi": "Green slopes",
  "piste_gialle": "Yellow tracks",
  "piste_rosse": "Red tracks",
  "piste_nere": "Black tracks",
  "piste_totali": "Total tracks",
  "impianti_invernali": "Winter",
  "impianti_estivi": "Summer",
  "accordion_impianti_titolo": "Installations",
  "impianti_totali": "Total installations",
  "accordion_attrezzature_titolo": "Equipment",
  "dettagli_account_outdoor": "Outdoor Operator Profile Details",
  "password_ripeti": "Repeat password",
  "avatar": "Profile image",
  "button_aggiorna_avatar": "Update avatar",
  "success_modifica_avatar": "Image successfully edited",
  "error_modifica_avatar": "A problem occurred while editing the image",
  "design": "Design",
  "servizio": "Tours and Activities",
  "pacchetto": "Weekends and Holidays",
  "proposte_per_te": "Proposals for you",
  "registrazione_incoming": "Register as Incoming Operator",
  "sito_web": "Web site",
  "servizi_pacchetti_proposti": "Proposed services and packages",
  "menu_pacchetti": "My packages and services",
  "menu_pacchetti_desc": "Displays or creates new packages or services",
  "tour_operator_incoming": "Tour operator incoming",
  "fornitori_servizi_turistici_singoli": "Tourist Service Providers",
  "consorzi_alberghieri": "Tourism Associations",
  "fornitori_servizi_trasporto": "Tourist transport supplier",
  "credits_progetto": "Design:",
  "credits_web": "Web development:",
  "fee_prenotazione": "Booking service",
  "chiusura_biglietteria": "Ticketing",
  "gestisci": "Manage",
  "prenota_spettacoli": "Book shows",
  "card_abbonamenti": "Torino+Piemonte Card and Royal Pass",
  "codice_non_disponibile": "Code not available",
  "abbonamento_informazioni": "Information",
  "abbonamento_cancellazione": "Deleting",
  "abbonamento_non_trovato": "Card not found",
  "prenota_visita_guidata": "Book a guided tour",
  "seleziona_data": "Select date",
  "button_aggiungi_posto": "Add Place",
  "visita_guidata_non_trovata": "Guided tour not found",
  "data_disponibile_singolare": "Available date",
  "data_disponibile_plurale": "available dates",
  "posto_disponibile_singolare": "Last place available for this date",
  "posto_disponibile_plurale": "places available for this date",
  "error_manca_lingua": "You must select a language",
  "error_carrello_prenotazione": "A problem occurred while adding this booking to the shopping cart",
  "disabled_data_annullata": "date cancelled",
  "disabled_posti_esauriti": "Sold out",
  "disabled_posti_non_disponibili": "unavailable places",
  "disabled_prenotabile_da_data": "bookable from the",
  "input_categoria": "Select a category",
  "input_codice_promozionale": "Promotional code",
  "carrello_vuoto": "Your shopping cart is empty",
  "error_codice_promozionale_troppo_presto": "The code entered is not yet valid",
  "error_codice_promozionale_troppo_tardi": "The entered code is no longer valid",
  "error_codice_promozionale_usato": "The code entered has already been used",
  "error_codice_promozionale_inesistente": "The entered code is invalid",
  "error_codice_promozionale_server": "It was not possible to verify the validity of this code",
  "error_manca_email_destinatario": "The recipient's address is mandatory",
  "error_autoregalo": " Select the address of the person you would like to gift this item",
  "crea_account": "Create a new account",
  "input_email_confim": "Write the e-mail again",
  "indirizzo_email_confirm": "Repeat e-mail",
  "input_password": "The password to be associated with the account",
  "preferenza_lingua": "Preferred language for communication",
  "input_preferenza_lingua": "Select a language",
  "button_registrati": "Register",
  "gia_registrato": "Already registered?",
  "gia_registrato_accedi": "Sign in",
  "gia_registrato_area": "to your reserved area.",
  "privacy_1b": "I have read the",
  "privacy_2b": "Conditions of purchase",
  "email_confirm_required": "The confirmation of email address is mandatory",
  "email_confirm_match": "Email addresses do not match",
  "preferenza_lingua_required": "The language preference is mandatory",
  "success_creazione_account": "Successful registration",
  "button_prosegui": "Continue",
  "button_accedi": "Sign in",
  "error_creazione_account": "A problem occurred during registration",
  "carrello_vuoto_sottotitolo": "Check out our proposals to make your stay special",
  "carrello_pieno": "Have you added everything to your cart?",
  "carrello_pieno_sottotitolo": "Before proceeding with your purchase, discover other experiences that can make your stay special!",
  "button_accetta": "Accept",
  "error_accettazione_regalo": "A problem occurred during gift acceptance",
  "notifica_carnet_regalato": "the gifted carnet",
  "notifica_carnet_associazione_1": "wants to associate the carnet",
  "notifica_carnet_associazione_2": "to your account",
  "parziale_lordo": "partial gross",
  "validita": "Validity",
  "disponibilita_posti": "Availability posts",
  "scaduta": "expired",
  "fino_al": "up to",
  "button_paga": "Pay",
  "carrello_acquista": "Buy",
  "error_checkout_prodotto": "One of the products in your shopping cart can no longer be purchased",
  "error_checkout_stock": "One of the products in your shopping cart exceeds the quantity currently available for purchase",
  "error_checkout_generico": "A problem occurred while preparing the checkout, please try again later",
  "error_pagamento": "A problem occurred during payment",
  "error_pagamento_creazione": "A problem occurred during payment creation",
  "km_da": "Km from",
  "km_da_te": "te",
  "prenota_spettacolo": "Book a show",
  "website": "Web Site",
  "abbonamento_musei": "Abbonamento Musei",
  "data_di_nascita_required": "the date of birth is mandatory",
  "error_data_di_nascita_non_valida": "The date of birth is invalid",
  "error_data_di_nascita_min": "You must be over",
  "error_data_di_nascita_max": "You must be under",
  "error_data_di_nascita_anni": "years of age",
  "tariffa_required": "The tariff is mandatory",
  "error_carrello_prodotto": "A problem occurred while adding this product to the shopping cart",
  "input_cap": "Your postcode",
  "input_indirizzo": "Your address",
  "input_codice": "Code",
  "input_ragione_sociale": "Name",
  "input_sede_legale_piva_cf": "Registered office code",
  "input_sede_legale_nazione": "Select the registered office's state",
  "input_sede_legale_indirizzo": "Address of registered office",
  "input_sede_legale_cap": "registered office postcode",
  "input_sede_legale_citta": "The city of the registered office",
  "input_sede_legale_cellulare": "Registered office number",
  "input_sede_legale_email": "Address of registered office",
  "button_modifica": "Edit",
  "crea_nuova_password": "Create a new password",
  "error_crea_nuova_password": "Password could not be changed. This link may be out of date or incorrect, please request a new one.",
  "button_nuovo_collegamento": "Request a new link",
  "button_vai_login": "Go to login",
  "crea_account_regalo": "Create an account to use your gift",
  "termini_condizioni": "Terms and conditions",
  "anni_011": "Children 0-11 years",
  "modifica_consenso_cookie": "Manage Cookies consent",
  "dontmiss_descrizione": "There are wonderful places to visit, enjoy and fall in love with.",
  "dontmiss_input": "Search for an attraction",
  "button_posti_esauriti": "Sold out",
  "login": "Login",
  "login_sottotitolo_1": "We are renewing our site to offer you an improved experience.",
  "login_sottotitolo_2": "If you were registered for the previous version of the site, you will need to re-register",
  "login_sottotitolo_qui": "here",
  "login_sottotitolo_3": "For information or other details about your purchases made before 5 November, please send an email to",
  "checkout_grazie": "Thank you for your purchase",
  "annullato": "Cancelled",
  "input_cerca_evento": "Name of the event",
  "tutti_tipi_strutture": "All types of structure",
  "input_tipo_struttura": "Structure type",
  "input_luogo": "Location (city)",
  "input_cerca_locale": "Name of the venue",
  "proposte_tour": "Tours and Activities",
  "proposte_weekend": "Weekends and Holidays",
  "proposte_outdoor": "Outdoor experiences",
  "tutte_le_proposte": "All proposals",
  "aderisce_a": "Adheres to",
  "nessuna_selezione": "No selection",
  "checkbox_newsletter": "I consent to the processing of my personal data in order to receive commercial and/or promotional communications via the Turismo Torino e Provincia newsletter.",
  "input_telefono": "Phone number",
  "dettagli_account_incoming": "Incoming Operator Profile Details",
  "tutte_le_tipologie_eventi": "All types of events",
  "nessun_risultato_prova_giorni": "No results: try selecting more days",
  "nessun_risultato_prova_proposte": "No results: try selecting all proposals",
  "concluso": "Expired",
  "aperto_visite_guidate": "Only guided tours",
  "posto": "SEAT",
  "posti": "SEATS",
  "la_proposta_comprende": "The offer includes",
  "proposte_turistiche": "Tourist offers",
  "acquista_altra_tpc": "Would you like to buy another one?",
  "acquista_altra_rp": "Would you like to buy another one?",
  "privacy_3b": "and the ",
  "privacy_4b": "Privacy Policy",
  "error_caricamento_avatar": "A problem occurred while loading the image",
  "error_immagine_troppo_grande": "The uploaded image is too large",
  "error_formato_immagine": "The image format is invalid",
  "error_aggiornamento_avatar": "A problem occurred while updating the avatar",
  "dati_non_pervenuti": "Data not received",
  "chiusura_temporanea": "Temporary closure",
  "suspended": "Not available today",
  "error_checkout_sconto": "An error occurred while applying the discount. Please report the problem or try again later.",
  "input_cerca_operatore": "Name of the operator",
  "durata_visita": "Tour duration",
  "visita_media": "Average visit",
  "visita_famiglia": "Family visit",
  "meno_1h": "Less than 1h",
  "1h_2h": "1 to 2 hours",
  "2h_3h": "2 to 3 hours",
  "oltre_3h": "Over 3 hours",
  "menu_locali": "Il mio locale",
  "menu_locali_desc": "Visualizza e gestisci il tuo locale",
  "evento_in_combinazione": "This event is available in conjunction with",
  "visita_singola": "Single visit",
  "tariffa_combinata": "Combined price",
  "button_applica_coupon": "Apply coupon"
}
export type TerminiEn = typeof termini_en
export const termini_fr = {
  "anno_costruzione": "Année de construction",
  "anno_ristrutturazione": "Année de restructuration",
  "accordion_tariffe_titolo": "Tarifs",
  "intero": "Billet complet",
  "ridotto": "réduit",
  "gratuito": "Gratuit",
  "famiglie": "Famille",
  "scuole": "Écoles",
  "gruppi": "Groupes",
  "offerta_libera": "Offre gratuite",
  "offerta_minima": "Offre minimum",
  "andata_ritorno": "Aller-retour",
  "insegnanti": "Enseignants",
  "anni_18": "Jusqu'à 18 ans",
  "anni_1825": "Entre 18 et 25 ans",
  "anni_1925": "Entre 19 et 25 ans",
  "anni_65": "Plus de 65 ans",
  "disabili": "Personnes handicapées",
  "accompagnatori": "Accompagnateurs des personnes avec handicap",
  "online": "Achats en ligne",
  "acquista": "Acheter",
  "prenota": "Réserver",
  "accordion_orari_titolo": "Horaires",
  "aperture_chiusure_straordinarie": "Ouvertures/fermetures extraordinaires",
  "aperto": "Ouvert",
  "chiuso": "Fermé",
  "aperto_prenotazione": "Sur réservation",
  "aperto_eventi": "Ouvert uniquement pour les événements",
  "apertura_settimanale": "Ouverture hebdomadaire",
  "apertura_mensile": "Ouverture mensuelle",
  "accordion_materiali_scaricabili_titolo": "Documents à télécharger",
  "ricettivita_categoria_1": "1 étoile",
  "ricettivita_categoria_2": "2 étoiles",
  "ricettivita_categoria_3": "3 étoiles",
  "ricettivita_categoria_4": "4 étoiles",
  "ricettivita_categoria_5": "5 étoiles",
  "ricettivita_categoria_5L": "luxe 5 étoiles",
  "accordion_risorse_umane_titolo": "Ressources humaines",
  "lingue_parlate_dipendenti": "Langues parlées par les employés",
  "accordion_spazi_congressuali_titolo": "Espaces de conférence",
  "area_superficie_espositiva": "Zone d'affichage",
  "mq_expo_aperto": "Surface d'exposition extérieure (m²)",
  "mq_expo_coperto": "Surface d'affichage couverte (m²)",
  "padiglioni": "Numéro de pavillon",
  "francese": "Français",
  "inglese": "Anglais",
  "italiano": "Italien",
  "sala_stampa": "Salle de presse",
  "servizi": "Services",
  "aree_comuni_zona_congressuale": "Espaces communs de la zone de conférence (m²)",
  "mq_foyer": "Accréditation / zone d'accréditation / distribution de la documentation / foyer",
  "mq_break": "Espace pause-café",
  "mq_reception": "Zone d'accueil",
  "mq_cocktail": "Espace cocktail / traiteur",
  "mq_poster": "Zone d'affichage",
  "mq_spazi_polivalenti": "Espaces polyvalents / Zone multifonctionnelle",
  "banco_registrazione": "Compteur pour l'enregistrement des participants",
  "guardaroba_custodito": "Armoire gardée",
  "guardaroba_incustodito": "Armoire sans surveillance",
  "magazzino": "Entrepôt à la disposition des organisateurs",
  "spazi_congressuali_interni": "Espaces de conférence disponibles en interne",
  "totale_sale": "Nombre total de pièces",
  "capienza_totale_sale": "Capacité totale de la salle",
  "massimo_posti_sala": "Nombre maximum de sièges dans la salle plus grande ",
  "accordion_elenco_sale_titolo": "Liste des salles",
  "totale_posti_a_sedere": "Nombre total de places assises",
  "totale_posti_in_piedi": "Capacité totale  debout",
  "mq_superficie": "Surface (m²)",
  "m_lunghezza": "Longueur (m)",
  "m_larghezza": "Largeur (m)",
  "m_altezza": "Hauteur du plafond (m)",
  "servizi_generici_sala": "Services génériques pour les chambres",
  "attrezzatura_audio": "Équipement audio",
  "attrezzatura_video": "Équipement vidéo",
  "attrezzatura_informatica": "Matériel informatique et télématique",
  "attrezzatura_traduzione": "Équipement de traduction simultanée",
  "accesso_internet": "Accès à l'internet et localisation",
  "wifi": "Wi-Fi",
  "impianto_traduzione_simultanea": "Facilité de traduction simultanée",
  "numero_cabine_fisse": "Nombre de cabines fixes",
  "capienza_tavolo_ferro": "Capacité table en fer à cheval",
  "capienza_banchi_scuola": "Capacité avec des pupitres de type scolaire",
  "capienza_teatro": "Capacité théâtrale",
  "capienza_tavolo_centrale": "Capacité de la table centrale",
  "capienza_tavolo_rotondo": "Capacité de la table ronde",
  "capienza_cocktail": "Capacité des cocktails",
  "totale_posti_tavolo": "Nombre total de places à la table des orateurs",
  "tipo_sedie": "Typologie des chaises",
  "tipo_tavolo": "Typologie des tables d'orateurs",
  "tipo_sala": "Type de pièce",
  "sedie_fisse": "Chaises fixes",
  "suddivisibile": "Divisible",
  "non_suddivisibile": "Non divisible",
  "sedie": "Chaises",
  "poltrone": "Fauteuils",
  "fisso": "Fixe",
  "asportabile": "Amovible",
  "accordion_servizi_titolo": "Services",
  "coperti_interni": "Couverts intérieur",
  "coperti_esterni": "Couverts extérieur",
  "coperti": "Couvert",
  "posti_dehor": "Places dehor",
  "posti_eventi": "Lieux d'événements",
  "posti_terrazza": "Places en terrasse",
  "posti_vista_panoramica": "Aperçu des lieux",
  "sale_riservate": "Nombre de chambres réservées",
  "accordion_cucina_titolo": "La cuisine",
  "button_acquista": "Acheter",
  "button_aggiungi_al_carrello": "Ajouter au panier",
  "nessuna_convenzione": "Pas de convention",
  "input_nome_intestatario": "Le nom du titulaire",
  "input_cognome_intestatario": "Le nom de famille du titulaire",
  "data_di_nascita": "Date de naissance",
  "input_giorno": "Jour",
  "input_mese": "Mois",
  "input_anno": "Année",
  "nome": "Nom",
  "cognome": "Nom de famille",
  "convenzioni": "Tarif réservé ",
  "tariffa": "Tarif",
  "mappa": "Carte",
  "vedi_mappa": "Vue sur la carte",
  "nascondi_mappa": "Cacher la carte",
  "tutte_le_categorie": "Toutes les catégories",
  "tutti_i_comuni": "Tous les éléments communs",
  "intorno_a_me": "Autour de moi",
  "oggi": "Aujourd'hui",
  "conferma": "Confirmation",
  "cerca": "Recherche",
  "tutti_i_target": "Toutes les cibles",
  "dove_mangiare": "Où manger",
  "dove_dormire": "Où dormir",
  "offerte": "Propositions",
  "dafarevedere": "A faire/à voir",
  "inprimopiano": "Points Forts",
  "convention": "Convention",
  "vedi_tutto": "Voir tous",
  "load_more": "Télécharger plus",
  "nessun_risultato": "Pas de résultat",
  "eventi": "Evénements",
  "vedi_tutti_risultati_per": "Voir tous les résultats pour",
  "anno_costituzione": "Année de création",
  "pagamenti_accettati": "Paiements acceptés",
  "lingue_parlate": "Langues parlées",
  "documento_commerciale": "Document commercial",
  "altitudine": "Altitude",
  "mslm": "mslm",
  "codice_cir": "Code CIR",
  "scopri_di_piu": "En savoir plus",
  "la_voglio_ora": "Je le veux tout de suite !",
  "prodotto_card": "Card",
  "prodotto_esperienza": "Expérience",
  "prodotto_progetto": "Projet",
  "prezzo_da": "De",
  "prezzo_a": "a",
  "prezzo_a_partire_da": "À partir de",
  "prezzo_fino_a": "Jusqu'à",
  "menu_degustazione": "Menu dégustation",
  "menu_sapori_torinesi": "Menu de dégustation Sapori Torinesi",
  "menu_gruppi": "Menus pour les groupes",
  "menu_bambino": "Menu enfant",
  "menu_business": "Menu d'entreprise",
  "brunch": "Brunch",
  "menu_turistico": "Menu touristique",
  "menu_famiglia": "Menu familial",
  "merenda_sinoira": "Merenda Sinoira",
  "fascia_di_prezzo": "Gamme de prix",
  "prezzi": "Prix",
  "punto_vendita": "Point de vente",
  "in_vendita_biglietteria": "En vente au guichet",
  "sede_di": "Siège de",
  "responsabile_congressi": "Gestionnaire de conférence",
  "menu_profilo": "Mon profil",
  "menu_ordini": "Mes commandes",
  "menu_card": "Mes cartes",
  "menu_logout": "Déconnexion",
  "menu_prenotazioni": "Mes réservations",
  "menu_attivita": "Mes activités",
  "menu_profilo_desc": "Consulter et modifier vos données personnelles",
  "menu_ordini_desc": "Voir tous vos achats",
  "menu_card_desc": "Visualisez et gérez toutes vos cartes",
  "menu_prenotazioni_desc": "Visualisez et gérez toutes vos réservations",
  "menu_attivita_desc": "Visualiser ou créer de nouvelles activités",
  "intestatario": "En-tête",
  "scadenza": "Date limite",
  "visualizza_qr": "Afficher QR",
  "anni_1217": "Junior 12-17 ans",
  "anni_12": "Sous 12",
  "accessori": "Accessoires",
  "seleziona_accessori": "Sélectionner les accessoires",
  "evento_parte_di": "Cet événement fait partie de",
  "totale": "Total",
  "vuoi_regalare_questo_articolo": "Souhaitez-vous offrir cet article en cadeau ?",
  "indirizzo_email": "Adresse électronique",
  "destinatario": "Destinataire",
  "lingua_preferita": "Langue préférée",
  "seleziona_lingua": "Sélectionner une langue",
  "data": "Date",
  "alta_stagione": "Haute saison",
  "bassa_stagione": "Basse saison",
  "apertura": "Ouverture",
  "accordion_persone_ammesse_titolo": "Personnes autorisées",
  "accordion_servizi_attivita_titolo": "Services et activités",
  "accordion_dotazioni_titolo": "Dotations",
  "accordion_capacita_ricettiva_titolo": "Capacité d'accueil",
  "camere": "Pièces",
  "posti_letto": "Lits",
  "camere_disabili": "Salles pour handicapés",
  "dotazioni_camera": "Équipements  de la chambre",
  "dotazioni_comune": "Caractéristiques communes",
  "dotazioni_bagno": "Salles de bains",
  "dotazioni_camere": "Installations des salles",
  "ospitalita": "L'hospitalité",
  "ristorazione": "Restauration",
  "animali": "Animaux",
  "colazione": "Petit déjeuner",
  "albergo": "Hôtel",
  "albergo_diffuso": "Hôtel éparpillé",
  "rta": "Résidence hôtelière touristique",
  "affittacamere": "Location",
  "agriturismo": "Ferme",
  "bed_and_breakfast": "Bed and Breakfast",
  "campeggio": "Le camping",
  "villaggio_turistico": "Village de vacances",
  "alloggio_vacanze": "Hébergement de vacances",
  "casa_vacanze": "Maison de vacances",
  "casa_ferie": "Maison de vacances",
  "country_house": "Maison de campagne",
  "ostello": "Auberge",
  "bivacco": "Bivouac fixe",
  "rifugio_alpino": "Abri alpin",
  "rifugio_escursionistico": "Abri de randonnée",
  "rifugio_non_gestito": "Abri non géré",
  "sri": "Installations d'accueil innovantes",
  "casa_della_giovane": "Accueil des jeune filles",
  "casa_indipendente": "Maison individuelle",
  "casa_religiosa_di_ospitalita": "Maison d'accueil religieuse",
  "case_indipendenti": "Maisons indépendantes",
  "cascina": "Exploitation agricole",
  "centro_benessere": "Centre de bien-être",
  "centro_di_soggiorno-studi": "Centre de séjour et d'études",
  "colonia": "Camp",
  "condhotel": "Condhotel",
  "condominio": "Immeuble",
  "dimora_storica": "Maison historique",
  "fabbricato_rurale": "Bâtiment rural",
  "foresteria": "Maison d'hôtes",
  "meuble_garni": "Meublé / Garnì",
  "motel": "Motel",
  "ostello_indipendente": "Auberge indépendante",
  "ostello_parte_di_un_circuito": "Auberge faisant partie de une chaîne",
  "pensionato_universitario": "Pension universitaire",
  "rifugio": "Halte",
  "villa_a_schiera": "Maison mitoyenne",
  "villa_indipendente": "Villa individuelle",
  "animali_non_ammessi": "Animaux non admis",
  "spazio_esterno_per_animali_domestici": "Espace extérieur pour animaux de compagnie",
  "animali_ammessi_al_guinzaglio": "Animaux autorisés en laisse",
  "pasti_a_cura_della_struttura": " Repas fournis par l'établissement",
  "animali_ammessi_in_camera": "Animaux admis dans la chambre",
  "colazione_non_compresa": "Petit déjeuner non inclus",
  "colazione_italiana_compresa": "Petit déjeuner italien compris",
  "colazione_italiana_a_parte": "Petit-déjeuner italien non inclus",
  "colazione_inglese_a_parte": "Petit-déjeuner anglais non inclus",
  "colazione_a_buffet_a_parte": "Petit-déjeuner buffet non inclus",
  "colazione_non_prevista": "Petit déjeuner non inclus",
  "prenotazione_obbligatoria": "Réservation obligatoire",
  "visitatori_ammessi": "Visiteurs autorisés",
  "studenti_ammessi": "Étudiants admis",
  "gruppi_ammessi": "Groupes autorisés",
  "visitatori_non_ammessi": "Visiteurs non autorisés",
  "disponibilita_bagni_privati_a_pagamento": "Toilettes privées payantes disponibles",
  "struttura_esclusiva_per_naturisti": "Structure réservée aux naturistes",
  "servizi_generali": "Services généraux",
  "uso_singola": "Chambre double pour une personne",
  "singola": "Chambre pour une personne",
  "singola_senza_bagno": "Chambre pour une personne sans toilette",
  "doppia": "Chambre double",
  "doppia_senza_bagno": "Chambre double sans salle de bain",
  "tripla": "Chambre pour trois personnes",
  "tripla_senza_bagno": "Chambre pour trois personnes sans salle de bain",
  "quattro_letti": "Quatre lits",
  "quattro_letti_senza_bagno": "Quatre lits chambre sans salle de bain",
  "suite": "Suite",
  "monolocale": "Studio",
  "bilocale": "Deux-pièces",
  "plurilocale": "Plusieurs pièces",
  "casa": "Accueil",
  "1giorno": "1 jour",
  "1settimana": "1 semaine",
  "2settimane": "2 semaines",
  "1mese": "1 mois",
  "adulti": "Adultes",
  "bambini": "Enfants",
  "auto": "Voiture",
  "moto": "Moto",
  "cani": "Chiens",
  "mobilhome": "Mobilhome",
  "chalet": "Chalet",
  "bungalow": "Bungalow",
  "bagno": "Avec salle de bain",
  "roulotte": "Caravanes",
  "camper": "Camping-car",
  "caravan": "Caravane",
  "tenda": "tente",
  "piazzola": "Dégagement",
  "camerate": "Dortoir",
  "mezza_pensione": "Demi-pension",
  "pensione_completa": "pension complète",
  "letto_in_aggiunta": "Lit supplémentaire",
  "casa_vacanza": "Maison de vacances",
  "ricettivita_categoria_3S": "3 étoiles supérieur",
  "ricettivita_categoria_1sp": "1 épi",
  "ricettivita_categoria_2sp": "2 épis",
  "ricettivita_categoria_3sp": "3 épis",
  "ricettivita_categoria_4sp": "4 épis",
  "ricettivita_categoria_5sp": "5 épis",
  "ricettivita_categoria_1g": "1 tournesol",
  "ricettivita_categoria_2g": "2 tournesols",
  "ricettivita_categoria_3g": "3 tournesols",
  "ricettivita_categoria_4g": "4 tournesols",
  "ricettivita_categoria_5g": "5 tournesols",
  "sport": "Sport",
  "possessori_carta": "Titulaires",
  "error_posizione_lettura": "Impossible de lire la position de cet appareil",
  "error_posizione_dispositivo": "Cet appareil n'est pas en mesure de partager sa position",
  "data_annullata": "Date annulée",
  "il_cuoco": "Le cuisinier",
  "periodo_consigliato": "Période recommandée",
  "accordion_informazioni_titolo": "Informations",
  "luogo_di_ritrovo": "Lieu de rendez-vous",
  "luogo_di_svolgimento": "Lieu",
  "durata": "Durée ",
  "modalita_prenotazione": "Modes de réservation",
  "le_sedi": "Les sites",
  "organizzato_da": "Organisé par",
  "accompagnatori_di_media_montagna": "Guides en moyenne montagne",
  "noleggi_attrezzature_sportive": "Location matériel de sport",
  "accompagnatori_naturalistici_o_guide_escursionistiche_ambientali": "Guides de randonnée environnementale",
  "accompagnatori_di_turismo_equestre": "Accompagnateurs pour le tourisme équestre",
  "organizzazioni_rappresentative_delle_categorie_del_bando": "Organisations d'activités de plein air",
  "guide_alpine": "Guides alpins",
  "accompagnatori_cicloturistici": "Accompagnaterus pour le cyclotourisme",
  "istruttori_di_canoa_e_kayak": "Moniteurs de canoë-kayak",
  "noleggi_biciclette": "Bicycle rentals",
  "trasporto_bagagli": "Transport de bagages et de vélos",
  "negozi_di_biciclette": "Magasins de vélos",
  "negozi_articoli_montagna": "Magasins d'articles de sport/matériel de montagne",
  "officine_riparazione_biciclette": "Ateliers de réparation de vélos",
  "aree_geografiche": "Zones géographiques",
  "attivita_proposte": "Activités proposées",
  "attivita_passate": "Activités passées",
  "eventi_correlati": "Evénements liés",
  "eventi_passati": "Événements passés",
  "bivacco_fisso": "Bivouac fixe",
  "casa_per_ferie": "Maison de vacances",
  "nessun_risultato_rircerca": "Pas de résultats de recherche",
  "in_questa_categoria": "dans cette catégorie",
  "prosegui_ricerca": "Poursuivre la recherche",
  "prodotti": "Produits",
  "aderenti": "Participants",
  "in_vendita_presso": "Où acheter?",
  "errore_404": "Page non trouvée",
  "login_non_ancora_account": "Vous n'avez pas enconre un compte?",
  "login_registrati_qua": "Créer un nouveau compte ici",
  "password": "Mot de passe",
  "login_dimenticato_password": "Vous avez oublié votre mot de passe ?",
  "login_accedi": "Se connecter",
  "error_manca_email": "Saisissez l'adresse électronique associée à votre compte",
  "error_email_non_valida": "Ce n'est pas une adresse électronique valide",
  "error_manca_password": "Ecrivez votre mot de passe",
  "error_login": "L'adresse électronique ou le mot de passe saisi est incorrect.",
  "login_recupera_password": "Récupération de mot de passe",
  "login_ricevuta_reset": "Demande reçue : vous recevrez bientôt un courriel contenant des instructions sur la manière de choisir un nouveau mot de passe.",
  "password_dimenticata": "Vous avez oublié votre mot de passe ?",
  "freccia": "Flèche",
  "apri": "Ouvrir",
  "meno_uno": "Moins un",
  "piu_uno": "Plus un",
  "rimuovi": "Retirer",
  "calendario": "Calendrier",
  "indietro": "Retour",
  "avanti": "Suivant",
  "documento": "Document",
  "telefono": "Téléphone",
  "condividi": "Partager",
  "condividi_su": "Partager sur",
  "carrello": "Panier d'achat",
  "skip_content": "Aller au contenu",
  "numero_ordine": "№ ordre",
  "ordine_effettuato_il": "L'ordre a fait le",
  "totale_scontato": "Total actualisé",
  "scontato_con_codice": "avec code",
  "accordion_contatti_titolo": "Contacts",
  "data_dal": "de",
  "data_mdal": "De",
  "data_al": "à",
  "data_finoal": "jusqu'à",
  "data_mfinoal": "Jusqu'à",
  "apertura_giornaliera": "Au quotidien",
  "operatori_outdoor": "Opérateurs extérieurs",
  "operatori_incoming": "Opérateurs entrants",
  "fornitori_di_trasporto": "Fournisseurs de transport",
  "sport_benessere": "Sport et bien-être",
  "benessere": "Bien-être",
  "dotazioni_chalet": "Équipement de chalet",
  "bagni": "Salles de bains",
  "stagione_unica": "Saison unique",
  "altre_informazioni": "Autres informations",
  "tipologia": "Typologie",
  "piscina_scoperta": "Piscine extérieure",
  "golf_numero_buche": "Nombre de trous",
  "golf_par": "Par",
  "golf_lunghezza_campo": "Longueur du champ",
  "modifica_profilo": "Modifier votre profil",
  "dettagli_account": "Détails du compte",
  "input_nome": "Votre nom",
  "input_cognome": "Votre nom de famille",
  "input_email": "L'adresse électronique à associer au compte",
  "input_cellulare": "Votre numéro de téléphone",
  "input_provenienza": "La ville d'origine",
  "cellulare": "Numéro de téléphone mobile",
  "input_nazione": "Choisir l'état",
  "citta": "Villes",
  "nazione": "Pays",
  "button_aggiorna_informazioni": "Mise à jour des informations",
  "modifica_password": "Changer le mot de passe",
  "password_minuscola": "Au moins une lettre minuscule",
  "password_maiuscola": "Au moins une lettre majuscule",
  "password_numero": "Au moins un numéro",
  "password_lunghezza": "d'une longueur minimale de 8 caractères",
  "input_password_nuova": "Votre nouveau mot de passe",
  "input_password_ripeti": "Confirmer le mot de passe",
  "password_confirm": "Répéter le mot de passe",
  "password_criteri": "Le mot de passe doit répondre aux critères suivants",
  "button_aggiorna_password": "Mise à jour du mot de passe",
  "nome_required": "Le nom est obligatoire",
  "cognome_required": "Le nom de famille est obligatoire",
  "numero_required": "Le numéro est obligatoire",
  "citta_required": "La ville est obligatoire",
  "nazione_required": "Le pays est obligatoire",
  "campo_required": "Ce champ est obligatoire",
  "password_required": "Le mot de passe est obligatoire",
  "password_safe": "Le mot de passe choisi n'est pas assez sûr",
  "confirm_required": "La confirmation du mot de passe est obligatoire",
  "confirm_match": "Les mots de passe ne correspondent pas",
  "email_invalid": "Ce n'est pas une adresse électronique valide",
  "email_required": "L'adresse électronique est obligatoire",
  "email_existing": "Cette adresse électronique a déjà été utilisée",
  "success_modifica_account": "Compte modifié avec succès",
  "error_modifica_account": "Un problème est survenu lors de la modification du compte",
  "success_modifica_password": "Mot de passe modifié avec succès",
  "error_modifica_password": "Un problème est survenu lors de la modification du mot de passe",
  "promuovi_evento": "Promouvoir un événement",
  "promuovi_ristorante": "Promouvoir un restaurant",
  "registrazione_outdoor": "S'inscrire en tant qu'opérateur extérieur",
  "link_utili": "Liens utiles",
  "ordini_empty": "Les commandes que vous passez et les documents commerciaux qui s'y rapportent apparaissent ici.",
  "card_empty": "Les carnets Armonia et les cartes Torino+Piemonte et Royal Pass que vous achetez apparaissent ici.",
  "prenotazioni_empty": "Les réservations que vous effectuez apparaissent ici.",
  "dotazioni_bungalow": "Équipement de bungalow",
  "camere_bungalow": "Chambres de plain-pied",
  "senza_bagno": "Sans salle de bain",
  "camere_chalet": "Chambres de chalet",
  "camere_mobilhome": "Chambres de maisons mobiles",
  "camere_caravan": "Chambres de caravanes",
  "bungalow_bagno": "Bungalow avec salle de bain",
  "bungalow_senza_bagno": "Bungalow sans salle de bain",
  "camere_e_suite_bagno": "Chambres et suites avec salle de bain",
  "bagni_comuni_disabili": "Toilettes communes pour handicapés",
  "input_email_newsletter": "L'email pour s'inscrire",
  "input_nome_scuola": "Nom de l'école/institution",
  "input_tipologia_scuola": "Choisir le type d'école",
  "input_societa": "Votre entreprise",
  "input_interesse": "Choisir un centre d'intérêt",
  "input_ruolo": "Rôle",
  "button_iscriviti": "S'inscrire",
  "scuola": "L'école",
  "nome_societa": "Nom de l'entreprise",
  "interesse_educational": "Intérêt pédagogique",
  "qualifica": "Qualification",
  "privacy": "Vie privée",
  "nessuno": "Aucun",
  "sci_montagna_invernale": "Ski et montagne d'hiver",
  "trekking_estivo": "Randonnée d'été",
  "city_break": "City break",
  "newsletter_success": "Enregistrement réussi",
  "newsletter_error": "Un problème est survenu lors de l'inscription à la lettre d'information",
  "nome_scuola_required": "Le nom de l'institution est obligatoire",
  "tipologia_scuola_required": "La typologie de l'institution est obligatoire",
  "societa_required": "Le nom de l'entreprise est obligatoire",
  "scuola_primaria": "Primaire",
  "scuola_secondaria_primo_grado": "Secondaire",
  "scuola_secondaria_secondo_grado": "Secondaire",
  "privacy_1": "J'ai lu le",
  "privacy_2": "le traitement des données à caractère personnel",
  "non_disponibile": "Non disponible",
  "disponibile_dal": "Disponible à partir de",
  "dotazioni_appartamenti": "Installations plates",
  "accordion_raggiungibilita_titolo": "Accessibilité",
  "informazioni_generali": "Informations générales",
  "minuti_dal_parcheggio": "A quelques minutes à pied du parking",
  "veicolo_necessario": "Véhicule nécessaire",
  "consigliato_fuoristrada": "Recommandé hors route",
  "strada_sterrata": "Chemin de gravier",
  "servizio_motoslitta_offerto_dalla_struttura": "Service de motoneige offert par l'établissement",
  "raggiungibile_a_piedi": "Accessible à pied",
  "raggiungibile_con_sci": "Accessible par ski",
  "strada_asfaltata": "Route pavée",
  "in_isola_pedonale": "Dans le passage piéton",
  "in_zona_a_traffico_limitato": "Dans une zone de circulation restreinte",
  "raggiungibile_con_muli_o_cavalli": "Accessible avec des mules ou des chevaux",
  "raggiungibile_con_racchette_da_neve": "Accessible en raquettes",
  "sci_alpino": "Ski alpin",
  "sci_fondo": "Ski de fond",
  "piste_blu": "Pentes bleues",
  "piste_verdi": "Pentes vertes",
  "piste_gialle": "Pistes jaunes",
  "piste_rosse": "Pistes rouges",
  "piste_nere": "Pistes noires",
  "piste_totali": "Total des pistes",
  "impianti_invernali": "L'hiver",
  "impianti_estivi": "L'été",
  "accordion_impianti_titolo": "Installations",
  "impianti_totali": "Nombre total d'installations",
  "accordion_attrezzature_titolo": "Equipement",
  "dettagli_account_outdoor": "Détails du profil de l'opérateur extérieur",
  "password_ripeti": "Répéter le mot de passe",
  "avatar": "Image de profil",
  "button_aggiorna_avatar": "Mise à jour de l'avatar",
  "success_modifica_avatar": "Image modifiée avec succès",
  "error_modifica_avatar": "Un problème est survenu lors de l'édition de l'image",
  "design": "Design",
  "servizio": "Visites et Activités",
  "pacchetto": "Weekends et Séjours",
  "proposte_per_te": "Propositions pour vous",
  "registrazione_incoming": "S'enregistrer en tant qu'opérateur entrant",
  "sito_web": "Site web",
  "servizi_pacchetti_proposti": "Services et forfaits proposés",
  "menu_pacchetti": "Mes paquets et services",
  "menu_pacchetti_desc": "Affiche ou crée de nouveaux paquets ou services",
  "tour_operator_incoming": "Voyagistes Réceptifs",
  "fornitori_servizi_turistici_singoli": "Fournisseurs de Services Touristiques",
  "consorzi_alberghieri": "Associations de Tourisme",
  "fornitori_servizi_trasporto": "Fournisseurs de Services des Transports",
  "credits_progetto": "Conception graphique:",
  "credits_web": "Développement web:",
  "fee_prenotazione": "Service de réservation",
  "chiusura_biglietteria": "Billetterie",
  "gestisci": "Gérer",
  "prenota_spettacoli": "Le livre montre",
  "card_abbonamenti": "Carte Torino+Piemonte et Royal Pass",
  "codice_non_disponibile": "Code non disponible",
  "abbonamento_informazioni": "Informations",
  "abbonamento_cancellazione": "Suppression",
  "abbonamento_non_trovato": "Carte non trouvée",
  "prenota_visita_guidata": "Réserver une visite guidée",
  "seleziona_data": "Sélectionner une date",
  "button_aggiungi_posto": "Ajouter un lieu",
  "visita_guidata_non_trovata": "Visite guidée introuvable",
  "data_disponibile_singolare": "date disponible",
  "data_disponibile_plurale": "dates disponibles",
  "posto_disponibile_singolare": "Dernière place disponible pour cette date",
  "posto_disponibile_plurale": "places disponibles pour cette date",
  "error_manca_lingua": "Vous devez sélectionner une langue",
  "error_carrello_prenotazione": "Un problème est survenu lors de l'ajout de cette réservation au panier.",
  "disabled_data_annullata": "date annulée",
  "disabled_posti_esauriti": "Complet",
  "disabled_posti_non_disponibili": "lieux indisponibles",
  "disabled_prenotabile_da_data": "réservables à partir de la page",
  "input_categoria": "Choisir une catégorie",
  "input_codice_promozionale": "Code promotionnel",
  "carrello_vuoto": "Ton panier est vide",
  "error_codice_promozionale_troppo_presto": "Le code saisi n'est pas encore valide",
  "error_codice_promozionale_troppo_tardi": "Le code saisi n'est plus valide",
  "error_codice_promozionale_usato": "Le code saisi a déjà été utilisé",
  "error_codice_promozionale_inesistente": "Le code saisi n'est pas valide",
  "error_codice_promozionale_server": "Il n'a pas été possible de vérifier la validité de ce code.",
  "error_manca_email_destinatario": "L'adresse du destinataire est obligatoire",
  "error_autoregalo": "Choisissez l'adresse d'une autre personne à qui vous souhaitez offrir cet article.",
  "crea_account": "Créer un nouveau compte",
  "input_email_confim": "Réécrire l'e-mail",
  "indirizzo_email_confirm": "Répéter l'e-mail",
  "input_password": "Le mot de passe à associer au compte",
  "preferenza_lingua": "Langue de communication préférée",
  "input_preferenza_lingua": "Choisir une langue",
  "button_registrati": "S'inscrire",
  "gia_registrato": "Déjà enregistré ?",
  "gia_registrato_accedi": "S'inscrire",
  "gia_registrato_area": "dans votre domaine réservé.",
  "privacy_1b": "J'ai lu les",
  "privacy_2b": "Conditions d'achat",
  "email_confirm_required": "La confirmation de l'adresse électronique est obligatoire",
  "email_confirm_match": "Les adresses électroniques ne correspondent pas",
  "preferenza_lingua_required": "La préférence linguistique est obligatoire",
  "success_creazione_account": "Enregistrement réussi",
  "button_prosegui": "Continuer",
  "button_accedi": "S'inscrire",
  "error_creazione_account": "Un problème est survenu lors de l'enregistrement",
  "carrello_vuoto_sottotitolo": "Découvre comment rendre ton séjour unique grâce à nos propositions.",
  "carrello_pieno": "As-tu tout mis dans ton panier?",
  "carrello_pieno_sottotitolo": "Avant de procéder à ton achat, découvre d'autres expériences qui peuvent rendre ton séjour unique!",
  "button_accetta": "Accepter",
  "error_accettazione_regalo": "Un problème est survenu lors de l'acceptation du cadeau",
  "notifica_carnet_regalato": "vous a remis le carnet",
  "notifica_carnet_associazione_1": "veut associer le carnet",
  "notifica_carnet_associazione_2": "à votre compte",
  "parziale_lordo": "brut partiel",
  "validita": "Validité",
  "disponibilita_posti": "Postes de disponibilité",
  "scaduta": "expiré",
  "fino_al": "jusqu'à",
  "button_paga": "Payer",
  "carrello_acquista": "Acheter",
  "error_checkout_prodotto": "L'un des produits de votre panier ne peut plus être acheté.",
  "error_checkout_stock": "L'un des produits de votre panier dépasse la quantité actuellement disponible à l'achat.",
  "error_checkout_generico": "Un problème est survenu lors de la préparation de la caisse, veuillez réessayer plus tard.",
  "error_pagamento": "Un problème est survenu lors du paiement",
  "error_pagamento_creazione": "Un problème est survenu lors de la création du paiement",
  "km_da": "Km de",
  "km_da_te": "te",
  "prenota_spettacolo": "Réserver un spectacle",
  "website": "Site web",
  "abbonamento_musei": "Abbonamento Musei",
  "data_di_nascita_required": "La date de naissance est obligatoire",
  "error_data_di_nascita_non_valida": "La date de naissance n'est pas valide",
  "error_data_di_nascita_min": "Vous devez avoir au moins ",
  "error_data_di_nascita_max": "Vous devez avoir au maximum",
  "error_data_di_nascita_anni": "années d'âge",
  "tariffa_required": "Le tarif est obligatoire",
  "error_carrello_prodotto": "Un problème est survenu lors de l'ajout de ce produit au panier.",
  "input_cap": "Votre code postal",
  "input_indirizzo": "Votre adresse",
  "input_codice": "Code",
  "input_ragione_sociale": "Nom de l'élément",
  "input_sede_legale_piva_cf": "Code du siège social",
  "input_sede_legale_nazione": "Choisissez l'état du siège social",
  "input_sede_legale_indirizzo": "Adresse du siège social",
  "input_sede_legale_cap": "code postal du siège social",
  "input_sede_legale_citta": "La ville du siège social",
  "input_sede_legale_cellulare": "Numéro du siège social",
  "input_sede_legale_email": "Adresse du siège social",
  "button_modifica": "Editer",
  "crea_nuova_password": "Créer un nouveau mot de passe",
  "error_crea_nuova_password": "Le mot de passe n'a pas pu être modifié. Ce lien peut être obsolète ou incorrect, veuillez en demander un nouveau.",
  "button_nuovo_collegamento": "Demander un nouveau lien",
  "button_vai_login": "Aller à la connexion",
  "crea_account_regalo": "Créez un compte pour profiter de votre cadeau",
  "termini_condizioni": "Conditions d'utilisation",
  "anni_011": "Enfants 0-11 ans",
  "modifica_consenso_cookie": "Modifier le consentement aux Cookies",
  "dontmiss_descrizione": "Il y a des endroits merveilleux à visiter, à apprécier et à aimer.",
  "dontmiss_input": "Rechercher une attraction",
  "button_posti_esauriti": "Complet",
  "login": "Connexion",
  "login_sottotitolo_1": "Nous sommes en train de mettre à jour notre site pour vous offrir une expérience encore plus plaisante.",
  "login_sottotitolo_2": "Si vous aviez été enregistré pour la version précédente du site, vous devriez vous réinscrire",
  "login_sottotitolo_qui": "ici",
  "login_sottotitolo_3": "Pour toute demande d'informations ou de renseignements supplémentaires sur vos achats effectués avant le 5 novembre, veuillez contacter",
  "checkout_grazie": "Merci pour votre achat",
  "annullato": "Annulé",
  "input_cerca_evento": "Nom de l'événement",
  "tutti_tipi_strutture": "Tous les types de structures",
  "input_tipo_struttura": "Type de structure",
  "input_luogo": "Lieu (ville)",
  "input_cerca_locale": "Nom de l'établissement",
  "proposte_tour": "Visites et Activités",
  "proposte_weekend": "Weekends et Séjours",
  "proposte_outdoor": "Expériences en plein air",
  "tutte_le_proposte": "Toutes les propositions",
  "aderisce_a": "Adhère à",
  "nessuna_selezione": "Aucune sélection",
  "checkbox_newsletter": "Je consens au traitement de mes données personnelles afin de recevoir des communications commerciales et/ou promotionnelles par le biais de la lettre d'information de Turismo Torino e Provincia.",
  "input_telefono": "Numéro de téléphone",
  "dettagli_account_incoming": "",
  "tutte_le_tipologie_eventi": "Tous types d'événements",
  "nessun_risultato_prova_giorni": "Pas de résultats : essayer de sélectionner plusieurs jours",
  "nessun_risultato_prova_proposte": "Pas de résultats : essayez de rechercher parmi toutes les propositions",
  "concluso": "Terminé",
  "aperto_visite_guidate": "Visites guidées uniquement",
  "posto": "PLACE",
  "posti": "PLACES",
  "la_proposta_comprende": "Cette offre comprend",
  "proposte_turistiche": "Produits touristiques",
  "acquista_altra_tpc": "Voulez-vous en acheter une autre?",
  "acquista_altra_rp": "Voulez-vous en acheter un autre? ",
  "privacy_3b": "et la ",
  "privacy_4b": "Politique de confidentialité",
  "error_caricamento_avatar": "Un problème est survenu lors du chargement de l'image",
  "error_immagine_troppo_grande": "L'image téléchargée est trop grande",
  "error_formato_immagine": "Le format de l'image n'est pas valide",
  "error_aggiornamento_avatar": "Un problème est survenu lors de la mise à jour de l'avatar",
  "dati_non_pervenuti": "Données non reçues",
  "chiusura_temporanea": "Fermeture temporaire",
  "suspended": "Non disponible aujourd'hui",
  "error_checkout_sconto": "Une erreur s'est produite lors de l'application de la réduction. Veuillez signaler le problème ou réessayer plus tard.",
  "input_cerca_operatore": "Nom de l'opérateur",
  "durata_visita": "Durée de la visite",
  "visita_media": "Durée moyenne",
  "visita_famiglia": "Familles",
  "meno_1h": "moins d'une heure",
  "1h_2h": "1 à 2 heures",
  "2h_3h": "2 à 3 heures",
  "oltre_3h": "Plus de 3 heures",
  "menu_locali": "Il mio locale",
  "menu_locali_desc": "Visualizza e gestisci il tuo locale",
  "evento_in_combinazione": "Cet événement peut être combiné avec",
  "visita_singola": "Visite simple",
  "tariffa_combinata": "Tarif combiné",
  "button_applica_coupon": "Appliquer le coupon"
}
export type TerminiFr = typeof termini_fr
